/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import MattersOpenedChart from './NewMatters/MattersOpenedChart';
import MattersByStatusChart from './MattersByStatusChart';
import { CurrentMatterChart } from './CurrentMatterChart';
import { MatterProfitabilityByCategoryChart } from './MatterProfitability/MatterProfitabilityByCategoryChart';
import { EstimatePerformanceChartV2 } from './EstimatePerformance/EstimatePerformanceChartV2';
import MattersVsAverageChart from './MattersVsAverage/MattersVsAverageChart';
import MattersByPeriodChart from './NewMatters/MattersByPeriodChart';
import MatterFeesVsEstimate from './EstimatePerformance/MatterFeesVsEstimate';
import BilledVsEstimateChart from './BilledVsEstimate/BilledVsEstimateChart';
import { BilledVsEstimateGroupedChart } from './BilledVsEstimate/BilledVsEstimateGroupedChart';
import { ExpectedFutureFeesChart } from './ExpectedFutureFees/ExpectedFutureFeesChart';
import { UnbilledFeesChart } from './UnbilledFees/UnbilledFeesChart';
import UnbilledDisbursementsChart from './UnbilledDisbursements/UnbilledDisbursementsChart';
import TotalOwingChart from './TotalOwing/TotalOwingChart';
import { DebtOwingChart } from './DebtOwing/DebtOwingChart';
import AverageFeeEstimatesCurrentChart from './AverageFeeEstimateCurrent/AverageFeeEstimatesCurrentChart';
import AverageBilledFeesChart from './AverageBilledFees/AverageBilledFeesChart';
import ClosedMattersChart from './ClosedMatters/ClosedMattersChart';
import { ClosedMattersByFeeEarnerChart } from './ClosedMatters/ClosedMattersByFeeEarnerChart';
import { AgedUnbilledFeesChart } from './AgedUnbilledFees/AgedUnbilledFeesChartV2';
import { NewMattersInLastTwelveMonthsGroupedChart } from './NewMatters/NewMattersInLastTwelveMonthsGroupedChart';
import InvoiceFeesBilledInLast14DaysChart from '../home/FeesBilledInLast14DaysChart/InvoiceFeesBilledInLast14DaysChart';
import InvoiceFeesBilledInLast12MonthsChart from '../home/FeesBilledInLast12Months/InvoiceFeesBilledInLast12MonthsChart';
import InvoiceFeesBilledInLastFinancialYearChart from './FeesBilledInLast12Months/InvoiceFeesBilledInLastFinancialYearChart';
import InvoiceFeesBilledInLastMonthChart from './FeesBilledInLast14DaysChart/InvoiceFeesBilledInLastMonthChart';
import { FeesBilledMonthToDateGroupedChart } from '../home/FeesBilledMonthToDate/FeesBilledMonthToDateGroupedChart';
import { InvoiceFeesBilledInLastYearGroupedChart } from '../home/FeesBilledInLastYear/InvoiceFeesBilledInLastYearGroupedChart';
import InvoiceInDraftGroupedChart from '../home/InvoiceInDraft/InvoiceInDraftGroupedChart';
import { NewLeadsInLast12MonthsTotal } from '../leadsDashboard/newLeads/NewLeadsInLast12MonthsTotal';
import NewLeadsInLast12MonthsByGroupChart, { NewLeadsEnum } from '../leadsDashboard/newLeads/NewLeadsInLast12MonthsByGroupChart';
import NewLeadsInLast30DaysByGroupChart from '../leadsDashboard/newLeads/NewLeadsInLast30DaysByGroupChart';
import { NewLeadsInLast7DaysByGroupChart } from '../leadsDashboard/newLeads/NewLeadsInLast7DaysByGroupChart';
import NewLeadsInLast90DaysByGroupChart from '../leadsDashboard/newLeads/NewLeadsInLast90DaysByGroupChart';
import AverageDaysLeadFollowUpByCategoryChart, { AverageLeadsFollowUpByEnum } from '../leadsDashboard/averageDaysLeadFollowUp/AverageDaysLeadFollowUpByCategoryChart';
import LeadConversationInLastByPeriodChart, { LeadConversationEnum } from '../leadsDashboard/leadConversation/LeadConversationInLastByPeriodChart';
import LeadsNotProceedingInLastByPeriodChart, { LeadsNotProceedingEnum } from '../leadsDashboard/leadsNotProceeding/LeadsNotProceedingInLastByPeriodChart';
import ReferralsByLeadQualityChart from '../leadsDashboard/referralsByLeadQuality/ReferralsByLeadQualityChart';
import MattersWithoutTrustGroupedChart from '../home/Activity/MattersWithoutTrustGroupedChart';
import MatterActivityChart from '../home/Activity/MatterActivityChart';
import PipelineVsMatterActivityChart from '../home/Activity/PipelineVsMatterActivityChart';
import { ClientExposureChart } from './clientExposure/ClientExposureChart';
import { TopReferrersByPeriodChart } from './Referrer/TopReferrersByPeriodChart';
import { TimeAndFeesRecordedInPeriodChart } from './Time/TimeAndFeesRecordedInPeriodChart';
import { FeesRecordedInPeriodChart } from './Time/FeesRecordedInPeriodChart';
import { TimeRecordedInPeriodChart } from './Time/TimeRecordedInPeriodChart';
import { TimeRecordedInFinancialYearChart } from './Time/TimeRecordedInFinancialYearChart';
import { FeesRecordedInFinancialYearChart } from './Time/FeesRecordedInFinancialYearChart';
import { TimeRecordedInFinancialYearAggregateChart } from './Time/TimeRecordedInFinancialYearAggregateChart';
import { FeesRecordedInFinancialYearAggregateChart } from './Time/FeesRecordedInFinancialYearAggregateChart';
import { FeesBilledPartChart } from './FeesBilled/FeesBilledPartChart';
import { FeesBilledVsBudgetPartChart } from './FeesBilled/FeesBilledVsBudgetPartChart';
import { FeesBilledCumulativePartChart } from './FeesBilled/FeesBilledCumulativePartChart';
import { FeesBilledCumulativeVsBudgetPartChart } from './FeesBilled/FeesBilledCumulativeVsBudgetPartChart';
import { FeesBilledByPeriodPartChart } from './FeesBilled/FeesBilledByPeriodPartChart';
import { FeesBilledVsBudgetByPeriodPartChart } from './FeesBilled/FeesBilledVsBudgetByPeriodPartChart';
import { FeesBilledVsBudgetByFeeEarnerChart } from './FeesBilled/FeesBilledVsBudgetByFeeEarnerChart';
import { FeesRecordedVsBudgetByFeeEarnerChart } from './Time/FeesRecordedVsBudgetByFeeEarnerChart';
import { FeesCollectedPartChart } from './FeesCollected/FeesCollectedPartChart';
import { FeesCollectedVsBudgetPartChart } from './FeesCollected/FeesCollectedVsBudgetPartChart';
import { FeesCollectedCumulativePartChart } from './FeesCollected/FeesCollectedCumulativePartChart';
import { FeesCollectedCumulativeVsBudgetPartChart } from './FeesCollected/FeesCollectedCumulativeVsBudgetPartChart';
import { FeesCollectedByPeriodPartChart } from './FeesCollected/FeesCollectedByPeriodPartChart';
import { FeesCollectedVsBudgetByPeriodPartChart } from './FeesCollected/FeesCollectedVsBudgetByPeriodPartChart';
import { FeesRecordedWithBudgetInPeriodChart } from './Time/FeesRecordedWithBudgetInPeriodChart';
import { TimeRecordedWithBudgetInPeriodChart } from './Time/TimeRecordedWithBudgetInPeriodChart';
import { TimeRecordedWithBudgetInFinancialYearChart } from './Time/TimeRecordedWithBudgetInFinancialYearChart';
import { FeesRecordedWithBudgetInFinancialYearChart } from './Time/FeesRecordedWithBudgetInFinancialYearChart';
import { TimeRecordedWithBudgetInFinancialYearAggregateChart } from './Time/TimeRecordedWithBudgetInFinancialYearAggregateChart';
import { FeesRecordedWithBudgetInFinancialYearAggregateChart } from './Time/FeesRecordedWithBudgetInFinancialYearAggregateChart';
import { BillingRealisationChart } from './BillingRealisation/BillingRealisationChart';
import { DebtorDaysChart } from './debtorDays/DebtorDaysChart';
import { WipLockupDaysChart } from './wipLockupDays/WipLockupDaysChart';
import { FutureSettlementsCharts } from './settlements/FutureSettlementsCharts';
import { FutureSettlementsByPriceChart } from './settlements/FutureSettlementsByPriceChart';
import { AverageMatterDurationChart } from './AverageMatterDuration/AverageMatterDurationChart';
import { SalesPipelineChart } from './salesPipeline/SalesPipelineChart';
import { EnquiriesByGroupChart } from './enquiriesByGroup/EnquiriesByGroupChart';
import { CollectionRateChart } from './CollectionRate/CollectionRateChart';
import { ClientBillingChart } from './ClientBilling/ClientBillingChart';
import { HoursRecordedByStaffMemberChart } from './HoursRecorded/HoursRecordedByStaffMemberChart';
import { NonBillableTimesByActivityChart } from './NonBillableTimes/NonBillableTimesByActivityChart';
import { NonBillableTimesByStaffChart } from './NonBillableTimes/NonBillableTimesByStaffChart';
import { DueDatesOverviewChart } from './dueDates/DueDatesOverviewChart';
import { TrustBalanceChart } from './trustBalance/TrustBalanceChart';
import { DueDatesByPersonChart } from './dueDates/DueDatesByPersonChart';
import { CrmMatterBillingChart } from './matterBilling/CrmMatterBillingChart';
import { BudgetYearChart } from './Budget/BudgetYearChart';
import { TaskQueueByPeriodChart } from './tasks/TaskQueueByPeriodChart';
import { CostAgreementsChart } from './CostAgreements/CostAgreementsChart';
import { TaskByCreationTimesChart } from './tasks/TaskByCreationTimesChart';
import { CumulativeBillableHoursVsBudgetChart } from './Time/CumulativeBillableHoursVsBudgetChart';

import { IAutoCompleteItem } from '../typings/autoComplete';
import { UserFeature, UserFeatureEnum } from '../types/UserFeature';
import { FeatureLayout, FeatureLayoutListData, FeatureLayoutParams, FEATURE_LAYOUT_QUERY } from './FeatureLayoutRepository';
import { useHistory } from 'react-router-dom';
import { Guid } from 'guid-typescript';
import { useQuery } from 'react-apollo';
import { DrillDownType } from './DrillDownType';
import { MaximizeChartDialog } from './MaximizeChartDialog';
import { FutureFeesChart } from './settlements/FutureFeesChart';
import { TrustFundsAvaialbleChart } from './TrustFundsAvailable/TrustFundsAvailableChart';
import { CombinedNewMattersChart } from './NewMatters/CombinedNewMattersChart';
import { NewMattersByPeriodsChart } from './NewMatters/NewMattersByPeriodsChart';
import { EnquiryActivityByPeriodChart } from './enquiryActivity/EnquiryActivityByPeriodChart';
import { MattersByCountryChart } from './mattersByCountry/MattersByCountryChart';
import { CurrentMattersByAustralianStatesChart } from './mattersByCountry/CurrentMattersByAustralianStatesChart';
import { USMapChart } from './mattersByCountry/USMapChart';
import { TrustBalanceByAgeChart } from './trustBalance/TrustBalanceByAgeChart';
import { FeesBilledVsBudgetSpeedometerChart } from './FeesBilled/FeesBilledVsBudgetSpeedometerChart';
import { TotalDebtOwingPieChart } from './TotalOwing/TotalDebtOwingPieChart';
import { BillableTimeByStaffChart } from './billableTime/BillableTimeByStaffChart';
import { FeesBilledVsBudgetByGroupChart } from './FeesBilled/FeesBilledVsBudgetByGroupChart';
import { BillableHoursRecordedVsBudgetChart } from './billableHoursRecordedVsBudget/BillableHoursRecordedVsBudgetChart';
import { KPISummaryChart } from './KPISummary/KPISummaryChart';
import { ForecastFeesBilledChart } from './MatterForecast/ForecastFeesBilledChart';
import { ForecastFeesCollectedChart } from './MatterForecast/ForecastFeesCollectedChart';
import { ForecastHoursChart } from './MatterForecast/ForecastHoursChart';
import { ForecastFeesBilledByCategoryChart } from './MatterForecast/ForecastFeesBilledByCategoryChart';
import { ForecastFeesCollectedByCategoryChart } from './MatterForecast/ForecastFeesCollectedByCategoryChart';
import { ForecastHoursByCategoryChart } from './MatterForecast/ForecastHoursByCategoryChart';
import { FeesRecordedVsBudgetSpeedometerChart } from './Time/FeesRecordedVsBudgetSpeedometerChart';

import { BillableHoursRecordedVsBudgetSpeedometerChart } from './billableHoursRecordedVsBudget/BillableHorusRecordedVsBudgetSpeedometerChart';
import { FeesCollectedVsBudgetSpeedometerChart } from './FeesCollected/FeesCollectedVsBudgetSpeedometerChart';
import { PhoneCallResponseTimeChart } from './tasks/PhoneCallResponseTimeChart';
import { TaskResponseTimeByAssigneeChart } from './tasks/TaskResponseTimeByAssigneeChart';
import { TaskResponseTimeByTaskTypeChart } from './tasks/TaskResponseTimeByTaskTypeChart';
import { AverageElapsedTimeByTaskTypeChart } from './tasks/AverageElapsedTimeByTaskTypeChart';
import { BudgetYearForecastChart } from './Budget/BudgetYearForecastChart';
import { CrmEnquiresDataHealthChart } from './CrmEnquiresDataHealth/CrmEnquiresDataHealthChart';
import { AverageElapsedTimeByAssigneeChart } from './tasks/AverageElapsedTimeByAssigneeChart';
import { ContactActivitiesByStaffChart } from './ClientAndContact/ContactActivitiesByStaffChart';
import { ContactActivityBySubjectChart } from './ContactActivity/ContactActivityBySubject';
import { WriteOffOnChart } from './writeOffOn/WriteOffOnChart';
import { EventsAndCampaignSummaryChart } from './eventsAndCampaignSummary/EventsAndCampaignSummaryChart';
import NewLeadsVsThreeYearsAverageChart from './leads/NewLeadsVsThreeYearsAverageChart';
import { CombinedNewLeadsByCategoryChart } from './leads/CombinedNewLeadsByCategoryChart';
import { NewLeadsInTheLastTwelveMonthsGroupedChart } from './leads/NewLeadsInTheLastTwelveMonthsGroupedChart';
import LeadsOpenedInTheLastTwelveMonthsChart from './leads/LeadsOpenedInTheLastTwelveMonthsChart';
import { EnquiryActivityByUserChart } from './enquiryActivity/EnquiryActivityByUserChart';
import { StaffUnbilledFeesChart } from './StaffUnbilledFees/StaffUnbilledFeesChart';
import { StaffUnbilledFeesByPeriodChart } from './StaffUnbilledFees/StaffUnbilledFeesByPeriodChart';
import { LazyChartItem } from './LazyChartItem';
import { useChartOptions } from './chartOptions/ChartOptionsContext';
import { ChartSkeleton } from '../components/loading/ChartSkeleton';
import { getChartSkeleton, getInitialSkeletonVariants, rememberDashboardLayout } from './chartSkeletons';
// import { TotalDebtOwingPieChart } from './TotalOwing/TotalDebtOwingPieChart';

export const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        '@media print': {
            display: 'block !important',
            margin: '0 !important',
        },
    },
    loadingWrapper: {
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    gridContainer: {
        posiiton: 'relative',
        '@media print': {
            pageBreakAfter: 'always',
            maxWidth: '100% !important',
            flex: 1,
            '& > div': {
                boxShadow: 'none !important',
            },
        },
    },
    contentContainer: {
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 14px 0 rgba(81,115,255,0.09)',
        display: 'inline-block',
        width: '100%',
        height: '100%',
        '& .item': {
            height: '100%',
        },
        '@media print': {
            boxShadow: 'none !important',
        },
    },
}));

export interface FeatureList {
    isMattersOpenedChartOpen: boolean;

    isByPeriodChartMatterType7Open: boolean;
    isByPeriodChartMatterCategory7Open: boolean;
    isByPeriodChartMatterCategoryAndType7Open: boolean;
    isByPeriodChartProperty7Open: boolean;
    isByPeriodChartPersonActing7Open: boolean;
    isByPeriodChartPersonResponsible7Open: boolean;
    isByPeriodChartMatterType30Open: boolean;
    isByPeriodChartMatterCategory30Open: boolean;
    isByPeriodChartMatterCategoryAndType30Open: boolean;
    isByPeriodChartProperty30Open: boolean;
    isByPeriodChartPersonActing30Open: boolean;
    isByPeriodChartPersonResponsible30Open: boolean;
    isByPeriodChartMatterType90Open: boolean;
    isByPeriodChartMatterCategory90Open: boolean;
    isByPeriodChartMatterCategoryAndType90Open: boolean;
    isByPeriodChartProperty90Open: boolean;
    isByPeriodChartPersonActing90Open: boolean;
    isByPeriodChartPersonResponsible90Open: boolean;

    isMattersVsAverageChartOpen: boolean;

    isCurrentMatterChartMatterTypeOpen: boolean;
    isCurrentMatterChartMatterCategoryOpen: boolean;
    isCurrentMatterChartMatterCategoryAndTypeOpen: boolean;
    isCurrentMatterChartPropertyOpen: boolean;
    isCurrentMatterChartPersonActingOpen: boolean;
    isCurrentMatterChartPersonResponsibleOpen: boolean;
    isCurrentMatterChartReportingGroupOpen: boolean;

    isMatterProfitabilityByCategoryChartOpen: boolean;
    isMatterProfitabilityByMatterTypeChartOpen: boolean;
    isMatterProfitabilityByPersonActingChartOpen: boolean;
    isMatterProfitabilityByPersonResponsibleChartOpen: boolean;
    isMatterProfitabilityByClientChartOpen: boolean;

    isMattersByStatusChartOpen: boolean;

    isEstimatePerformanceChartOpen: boolean;
    isMatterFeesVsEstimateChartOpen: boolean;

    isBilledVsEstimateChartOpen: boolean;

    isBilledFeesVsEstimateByMatterTypeChartOpen: boolean;
    isBilledFeesVsEstimateByMatterCategoryChartOpen: boolean;
    isBilledFeesVsEstimateByMatterCategoryAndTypeChartOpen: boolean;
    isBilledFeesVsEstimateByPropertyChartOpen: boolean;
    isBilledFeesVsEstimateByPersonActingChartOpen: boolean;
    isBilledFeesVsEstimateByPersonResponsibleChartOpen: boolean;

    isExpectedFutureFeesByMatterTypeChart: boolean;
    isExpectedFutureFeesByMatterCategoryChart: boolean;
    isExpectedFutureFeesByMatterCategoryAndTypeChart: boolean;
    isExpectedFutureFeesByPropertyChart: boolean;
    isExpectedFutureFeesByPersonActingChart: boolean;
    isExpectedFutureFeesByPersonResponsibleChart: boolean;

    isUnbilledFeesByMatterTypeChartOpen: boolean;
    isUnbilledFeesByMatterCategoryChartOpen: boolean;
    isUnbilledFeesByMatterCategoryAndTypeChartOpen: boolean;
    isUnbilledFeesByPropertyChartOpen: boolean;
    isUnbilledFeesByPersonActingChartOpen: boolean;
    isUnbilledFeesByPersonResponsibleChartOpen: boolean;

    isUnbilledDisbursementsByMatterTypeChartOpen: boolean;
    isUnbilledDisbursementsByMatterCategoryChartOpen: boolean;
    isUnbilledDisbursementsByMatterCategoryAndTypeChartOpen: boolean;
    isUnbilledDisbursementsByPropertyChartOpen: boolean;
    isUnbilledDisbursementsByPersonActingChartOpen: boolean;
    isUnbilledDisbursementsByPersonResponsibleChartOpen: boolean;

    isTotalOwingChartOpen: boolean;

    isDebtOwingByMatterTypeChartOpen: boolean;
    isDebtOwingByMatterCategoryChartOpen: boolean;
    isDebtOwingByMatterCategoryAndTypeChartOpen: boolean;
    isDebtOwingByPropertyChartOpen: boolean;
    isDebtOwingByPersonActingChartOpen: boolean;
    isDebtOwingByPersonResponsibleChartOpen: boolean;
    isDebtOwingByClientChartOpen: boolean;

    isClientExposureChartOpen: boolean;

    isAverageFeeEstimatesCurrentByMatterTypeChartOpen: boolean;
    isAverageFeeEstimatesCurrentByMatterCategoryChartOpen: boolean;
    isAverageFeeEstimatesCurrentByMatterCategoryAndTypeChartOpen: boolean;
    isAverageFeeEstimatesCurrentByPropertyChartOpen: boolean;
    isAverageFeeEstimatesCurrentByPersonActingChartOpen: boolean;
    isAverageFeeEstimatesCurrentByPersonResponsibleChartOpen: boolean;

    isAverageBilledFeesByMatterTypeChartOpen: boolean;
    isAverageBilledFeesByMatterCategoryChartOpen: boolean;
    isAverageBilledFeesByMatterCategoryAndTypeChartOpen: boolean;
    isAverageBilledFeesByPropertyChartOpen: boolean;
    isAverageBilledFeesByPersonActingChartOpen: boolean;
    isAverageBilledFeesByPersonResponsibleChartOpen: boolean;

    isClosedMattersChartOpen: boolean;

    isTrustExceptionsChartOpen: boolean;

    isCostAgreementsChartOpen: boolean;

    isAgedUnbilledFeesChartOpen: boolean;

    isFeesVsBudgetChartOpen: boolean;

    isOverallServiceRatingChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByMatterTypeChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByMatterCategoryChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByMatterCategoryAndTypeChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByPropertyChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByPersonActingChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByPersonResponsibleChartOpen: boolean;
    isNewMattersInLastTwelveMonthsByReportingGroupChartOpen: boolean;

    isMatterActivityChartOpen: boolean;
    isPipelineVsMatterActivityChartOpen: boolean;

    isMattersWithoutTrustByMatterTypeChartOpen: boolean;
    isMattersWithoutTrustByMatterCategoryChartOpen: boolean;
    isMattersWithoutTrustByMatterCategoryAndTypeChartOpen: boolean;
    isMattersWithoutTrustByPropertyChartOpen: boolean;
    isMattersWithoutTrustByPersonActingChartOpen: boolean;
    isMattersWithoutTrustByPersonResponsibleChartOpen: boolean;

    isFeesBilledInLast12MonthsOpen: boolean;
    isFeesBilledInLastFinancialYearOpen: boolean;
    isFeesBilledInLast14DaysMonthsOpen: boolean;
    isFeesBilledForMonthOpen: boolean;
    isFeesBilledMonthToDateByPersonActingOpen: boolean;
    isFeesBilledMonthToDateByPersonResponsibleOpen: boolean;
    isFeesBilledMonthToDateByMatterTypeOpen: boolean;
    isFeesBilledMonthToDateByMatterCategoryOpen: boolean;
    isFeesBilledMonthToDateByPropertyTypeOpen: boolean;
    isFeesBilledMonthToDateByReportingGroupOpen: boolean;
    isFeesBilledInLastYearByPersonActingOpen: boolean;
    isFeesBilledInLastYearByPersonResponsibleOpen: boolean;
    isFeesBilledInLastYearByMatterTypeOpen: boolean;
    isFeesBilledInLastYearByMatterCategoryOpen: boolean;
    isFeesBilledInLastYearByPropertyTypeOpen: boolean;
    isFeesBilledInLastYearByReportingGroupOpen: boolean;
    isInvoiceInDraftChartByPersonActingOpen: boolean;
    isInvoiceInDraftChartByPersonResponsibleOpen: boolean;
    isInvoiceInDraftChartByMatterTypeOpen: boolean;
    isInvoiceInDraftChartByMatterCategoryOpen: boolean;
    isInvoiceInDraftChartByPropertyTypeOpen: boolean;
    isInvoiceInDraftChartByReportingGroupOpen: boolean;

    IsNewLeadsInLast12MonthsTotalChartOpen: boolean;
    IsNewLeadsInLast12MonthsBySourceChartOpen: boolean;
    IsNewLeadsInLast12MonthsByAreaOfLawChartOpen: boolean;
    IsNewLeadsInLast30DaysBySourceChartOpen: boolean;
    IsNewLeadsInLast30DaysByAssigneeChartOpen: boolean;
    IsNewLeadsInLast30DaysByAreaOfLawChartOpen: boolean;
    IsNewLeadsInLast7DaysBySourceChartOpen: boolean;
    IsNewLeadsInLast7DaysByAreaOfLawChartOpen: boolean;
    IsNewLeadsInLast90DaysBySourceChartOpen: boolean;
    IsNewLeadsInLast90DaysByAreaOfLawChartOpen: boolean;
    IsAverageDaysLeadFollowUpByLawyerChartOpen: boolean;
    IsReferralsByLeadQualityChartOpen: boolean;
    IsLeadConversionInLast12MonthsByLawyerChartOpen: boolean;
    IsLeadsNotProceedingInLast12MonthsByReasonChartOpen: boolean;
    IsLeadConversionInLast30DaysByLawyerChartOpen: boolean;
    IsLeadsNotProceedingInLast30DaysByReasonChartOpen: boolean;
    IsLeadConversionInLast90DaysByLawyerChartOpen: boolean;
    IsLeadsNotProceedingInLast90DaysByReasonChartOpen: boolean;

    IsTopReferrersInLast30DaysChartOpen: boolean;
    IsTopReferrersInLast90DaysChartOpen: boolean;
    IsTopReferrersInLast12MonthsChartOpen: boolean;

    IsTimesheetTimeAndFeesInLastPeriodsChartOpen: boolean;
    IsTimesheetFeesInLastPeriodsChartOpen: boolean;
    IsTimesheetTimeInLastPeriodsChartOpen: boolean;
    IsTimesheetTimeInFinancialYearChartOpen: boolean;
    IsTimesheetFeesInFinancialYearChartOpen: boolean;
    IsTimesheetTimeInFinancialYearAggregateChartOpen: boolean;
    IsTimesheetFeesInFinancialYearAggregateChartOpen: boolean;

    isFeesBilledByPeriodPartChartOpen: boolean;
    isFeesBilledCumulativePartChartOpen: boolean;
    isFeesBilledCumulativeVsBudgetPartChartOpen: boolean;
    isFeesBilledPartChartOpen: boolean;
    isFeesBilledVsBudgetByPeriodPartChartOpen: boolean;
    isFeesBilledVsBudgetPartChartOpen: boolean;

    isFeesCollectedByPeriodPartChartOpen: boolean;
    isFeesCollectedCumulativePartChartOpen: boolean;
    isFeesCollectedCumulativeVsBudgetPartChartOpen: boolean;
    isFeesCollectedPartChartOpen: boolean;
    isFeesCollectedVsBudgetByPeriodPartChartOpen: boolean;
    isFeesCollectedVsBudgetPartChartOpen: boolean;

    isTimesheetFeesWithBudgetInLastPeriodsChartOpen: boolean;
    isTimesheetTimeWithBudgetInLastPeriodsChartOpen: boolean;
    isTimesheetTimeWithBudgetInFinancialYearChartOpen: boolean;
    isTimesheetFeesWithBudgetInFinancialYearChartOpen: boolean;
    isTimesheetTimeWithBudgetInFinancialYearAggregateChartOpen: boolean;
    isCumulativeBillableHoursVsBudgetChartOpen: boolean;
    isTimesheetFeesWithBudgetInFinancialYearAggregateChartOpen: boolean;

    isBillingRealisationChartOpen: boolean;

    isDebtorDaysByPersonActingChartOpen: boolean;
    isDebtorDaysByPersonResponsibleChartOpen: boolean;
    isDebtorDaysByMatterCategoryChartOpen: boolean;
    isDebtorDaysByMatterTypeChartOpen: boolean;
    isWIPLockUpDaysByPersonActingChartOpen: boolean;
    isWIPLockUpDaysByPersonResponsibleChartOpen: boolean;
    isWIPLockUpDaysByMatterCategoryChartOpen: boolean;
    isWIPLockUpDaysByMatterTypeChartOpen: boolean;

    isFutureSettlementsChartOpen: boolean;
    isFutureSettlementsByPriceChartOpen: boolean;

    isMatterDurationByCategoryOrTypeChartOpen: boolean;

    isSalesPipelineByAreaOfLawChartOpen: boolean;
    isSalesPipelineByAssigneeChartOpen: boolean;
    isSalesPipelineByLocationChartOpen: boolean;

    isEnquiriesByQualityChartOpen: boolean;
    isEnquiriesByLikelihoodToProceedChartOpen: boolean;

    isCollectionRateChartOpen: boolean;
    isClientBillingChartOpen: boolean;

    isHoursRecordedByStaffMembersChartOpen: boolean;
    isNonBillableTimesByActivityChartOpen: boolean;
    isNonBillableTimesByStaffChartOpen: boolean;
    isBillableTimesByStaffChartOpen: boolean;
    isDueDatesOverviewChartOpen: boolean;
    isTrustBalanceChartOpen: boolean;
    isDueDatesByPersonChartOpen: boolean;
    isMatterBillingChartOpen: boolean;
    isYearBudgetsChartOpen: boolean;
    isTaskQueueByAssigneeChartOpen: boolean;
    isTaskQueueByTaskTypeDescriptionChartOpen: boolean;
    isTaskQueueByCreationTimeChart: boolean;
    isFutureFeesChart: boolean;
    isClosedMattersByFeeEarnerChartOpen: boolean;
    isFeesBilledVsBudgetByFeeEarnerChartOpen: boolean;
    isFeesRecordedVsBudgetByFeeEarnerChartOpen: boolean;
    isFinancialYearBudgetForecastChart: boolean;

    isTrustFundsAvailableChartOpen: boolean;
    isCombinedNewMattersChartByCategoryOpen: boolean;
    isNewMattersByPeriodsChartOpen: boolean;

    isMattersByCountryChartOpen: boolean;
    isCurrentMattersByAustralianStateChartOpen: boolean;

    isTrustBalancesByAgeChartOpen: boolean;
    isFeesBilledVsBudgetSpeedometerChartOpen: boolean;
    isTotalDebtOwingPieOpen: boolean;

    isFeesBilledVsBudgetByOfficeChartOpen: boolean;
    isFeesBilledVsBudgetByTeamChartOpen: boolean;
    isFeesBilledVsBudgetByDepartmentChartOpen: boolean;

    isBillableHoursRecordedVsBudgetOpen: boolean;

    isKpiSummaryOpen: boolean;

    isForecastFeesBilledChartOpen: boolean;
    isForecastFeesCollectedChartOpen: boolean;
    isForecastHoursChartOpen: boolean;

    isForecastFeesBilledByCategoryChartOpen: boolean;
    isForecastFeesCollectedByCategoryChartOpen: boolean;
    isForecastHoursByCategoryChartOpen: boolean;
    isFeesRecordedVsBudgetSpeedometerChartOpen: boolean;
    isFeesCollectedVsBudgetSpeedometerChartOpen: boolean;

    isBillableHoursRecordedVsBudgetSpeedometerOpen: boolean;

    isPhoneCallResponseTimeChartOpen: boolean;
    isTaskResponseTimeByAssigneeChartOpen: boolean;
    isTaskResponseTimeByTaskTypeChartOpen: boolean;
    isAverageElapsedTimeByTaskTypeChartOpen: boolean;
    isAverageElapsedTimeByAssigneeChartOpen: boolean;

    isEnquiryHealthChartOpen: boolean;
    isContactActivitiesByStaffChartOpen: boolean;
    isContactActivitiesBySubjectChartOpen: boolean;

    isWriteOffOrOnAnalysisChartOpen: boolean;
    
    isNewMatterLeadsInLastTwelveMonthsByMatterTypeChartOpen: boolean;
    isNewMatterLeadsInLastTwelveMonthsByMatterCategoryChartOpen: boolean;
    isNewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChartOpen: boolean;
    isNewMatterLeadsInLastTwelveMonthsByPropertyChartOpen: boolean;
    isNewMatterLeadsInLastTwelveMonthsByActingChartOpen: boolean;
    isNewMatterLeadsInLastTwelveMonthsByResponsibleChartOpen: boolean;
    isNewMatterLeadsVsThreeYearAverageChartOpen: boolean;
    isCombinedNewMatterLeadsByCategoryChartOpen: boolean;
    isMatterLeadsOpenedLastTwelveMonthsOpen: boolean;
    isEnquiryActivityByPeriodChartOpen: boolean;
    isEnquiryActivityByUserChartOpen: boolean;
    isStaffUnbilledFeesChartOpen: boolean;
    isStaffUnbilledFeesByPeriodChartOpen: boolean;
}

export interface ChartFilter {
    entityType: number | undefined; // 0 - Firm, 1 - Office, 2 - Department, 3 - Team, 4 - User, 5 - Staff/Fee Earner/Referrer (Name Guid), 6 - Repprting Group
    entityGuid?: string;
    responsibility?: number; // 1 - Person Responsible, 2 - Person Acting
    dashboardPanel?: IAutoCompleteItem;
    userAssistant?: IAutoCompleteItem;
    externalUser?: IAutoCompleteItem;
    filter?: string;
}

export enum DashboardTypeEnum {
    FIRM = 0,
    LEAD = 1,
    FEE_EARNER = 2,
    TASK = 3,
    ClientDashboard = 4,
    ClientAndContactDetailsClientDashboard = 8
}

export enum DashboardEntityTypeEnum {
    Firm = 0,
    Office = 1,
    Department = 2,
    Team = 3,
    User = 4,
    Staff = 5,
    FeeEarner = 6,
    ReportingGroup = 7,
    Client = 8,
}

interface ChartComponentsProps {
    chartFilter: ChartFilter;
    layoutId: DashboardTypeEnum;
    isRefresh: boolean;
    onRefresh?: (isRefresh: boolean) => void;
    search: string;
    isFromSidebar?: boolean;
}

interface ChartComponentsState {
    feature: FeatureList;
    featureLayoutList: FeatureLayout[];
    isMaximizeOpen: boolean;
    selectedOption?: number;
    additionalOption?: number;
    selectedFeatureLayout: FeatureLayout | null;
    maximizeSelected?: {
        // tslint:disable-next-line: no-any
        [key: string]: any;
    };
}

export const ChartComponents: React.FC<ChartComponentsProps> = (props) => {
    const { registerFeatureNames } = useChartOptions();
    const classes = useStyles();

    const history = useHistory();

    const [loading, setLoading] = useState<boolean>(true);
    const [featureLayoutList, setFeatureLayoutList] = useState<FeatureLayout[]>([]);

    const [state, setState] = useState<ChartComponentsState>({
        selectedFeatureLayout: null,
        isMaximizeOpen: false,
        feature: {
            isMattersOpenedChartOpen: true,
            isByPeriodChartMatterType7Open: true,
            isByPeriodChartMatterCategory7Open: true,
            isByPeriodChartMatterCategoryAndType7Open: true,
            isByPeriodChartProperty7Open: true,
            isByPeriodChartPersonActing7Open: true,
            isByPeriodChartPersonResponsible7Open: true,
            isByPeriodChartMatterType30Open: true,
            isByPeriodChartMatterCategory30Open: true,
            isByPeriodChartMatterCategoryAndType30Open: true,
            isByPeriodChartProperty30Open: true,
            isByPeriodChartPersonActing30Open: true,
            isByPeriodChartPersonResponsible30Open: true,
            isByPeriodChartMatterType90Open: true,
            isByPeriodChartMatterCategory90Open: true,
            isByPeriodChartMatterCategoryAndType90Open: true,
            isByPeriodChartProperty90Open: true,
            isByPeriodChartPersonActing90Open: true,
            isByPeriodChartPersonResponsible90Open: true,
            isMattersVsAverageChartOpen: true,
            isCurrentMatterChartMatterTypeOpen: true,
            isCurrentMatterChartMatterCategoryOpen: true,
            isCurrentMatterChartMatterCategoryAndTypeOpen: true,
            isCurrentMatterChartPropertyOpen: true,
            isCurrentMatterChartPersonActingOpen: true,
            isCurrentMatterChartPersonResponsibleOpen: true,
            isCurrentMatterChartReportingGroupOpen: true,
            isMatterProfitabilityByCategoryChartOpen: true,
            isMatterProfitabilityByMatterTypeChartOpen: true,
            isMatterProfitabilityByPersonActingChartOpen: true,
            isMatterProfitabilityByPersonResponsibleChartOpen: true,
            isMatterProfitabilityByClientChartOpen: true,
            isMattersByStatusChartOpen: true,
            isEstimatePerformanceChartOpen: true,
            isMatterFeesVsEstimateChartOpen: true,
            isBilledVsEstimateChartOpen: true,
            isBilledFeesVsEstimateByMatterTypeChartOpen: true,
            isBilledFeesVsEstimateByMatterCategoryChartOpen: true,
            isBilledFeesVsEstimateByMatterCategoryAndTypeChartOpen: true,
            isBilledFeesVsEstimateByPropertyChartOpen: true,
            isBilledFeesVsEstimateByPersonActingChartOpen: true,
            isBilledFeesVsEstimateByPersonResponsibleChartOpen: true,
            isExpectedFutureFeesByMatterTypeChart: true,
            isExpectedFutureFeesByMatterCategoryChart: true,
            isExpectedFutureFeesByMatterCategoryAndTypeChart: true,
            isExpectedFutureFeesByPropertyChart: true,
            isExpectedFutureFeesByPersonActingChart: true,
            isExpectedFutureFeesByPersonResponsibleChart: true,
            isUnbilledFeesByMatterTypeChartOpen: true,
            isUnbilledFeesByMatterCategoryChartOpen: true,
            isUnbilledFeesByMatterCategoryAndTypeChartOpen: true,
            isUnbilledFeesByPropertyChartOpen: true,
            isUnbilledFeesByPersonActingChartOpen: true,
            isUnbilledFeesByPersonResponsibleChartOpen: true,
            isUnbilledDisbursementsByMatterTypeChartOpen: true,
            isUnbilledDisbursementsByMatterCategoryChartOpen: true,
            isUnbilledDisbursementsByMatterCategoryAndTypeChartOpen: true,
            isUnbilledDisbursementsByPropertyChartOpen: true,
            isUnbilledDisbursementsByPersonActingChartOpen: true,
            isUnbilledDisbursementsByPersonResponsibleChartOpen: true,
            isTotalOwingChartOpen: true,
            isDebtOwingByMatterTypeChartOpen: true,
            isDebtOwingByMatterCategoryChartOpen: true,
            isDebtOwingByMatterCategoryAndTypeChartOpen: true,
            isDebtOwingByPropertyChartOpen: true,
            isDebtOwingByPersonActingChartOpen: true,
            isDebtOwingByPersonResponsibleChartOpen: true,
            isDebtOwingByClientChartOpen: true,
            isClientExposureChartOpen: true,
            isAverageFeeEstimatesCurrentByMatterTypeChartOpen: true,
            isAverageFeeEstimatesCurrentByMatterCategoryChartOpen: true,
            isAverageFeeEstimatesCurrentByMatterCategoryAndTypeChartOpen: true,
            isAverageFeeEstimatesCurrentByPropertyChartOpen: true,
            isAverageFeeEstimatesCurrentByPersonActingChartOpen: true,
            isAverageFeeEstimatesCurrentByPersonResponsibleChartOpen: true,
            isAverageBilledFeesByMatterTypeChartOpen: true,
            isAverageBilledFeesByMatterCategoryChartOpen: true,
            isAverageBilledFeesByMatterCategoryAndTypeChartOpen: true,
            isAverageBilledFeesByPropertyChartOpen: true,
            isAverageBilledFeesByPersonActingChartOpen: true,
            isAverageBilledFeesByPersonResponsibleChartOpen: true,
            isClosedMattersChartOpen: true,
            isTrustExceptionsChartOpen: true,
            isCostAgreementsChartOpen: true,
            isAgedUnbilledFeesChartOpen: true,
            isFeesVsBudgetChartOpen: true,
            isOverallServiceRatingChartOpen: true,
            isNewMattersInLastTwelveMonthsByMatterTypeChartOpen: true,
            isNewMattersInLastTwelveMonthsByMatterCategoryChartOpen: true,
            isNewMattersInLastTwelveMonthsByMatterCategoryAndTypeChartOpen: true,
            isNewMattersInLastTwelveMonthsByPropertyChartOpen: true,
            isNewMattersInLastTwelveMonthsByPersonActingChartOpen: true,
            isNewMattersInLastTwelveMonthsByPersonResponsibleChartOpen: true,
            isNewMattersInLastTwelveMonthsByReportingGroupChartOpen: true,

            isMatterActivityChartOpen: true,
            isPipelineVsMatterActivityChartOpen: true,
            isMattersWithoutTrustByMatterTypeChartOpen: true,
            isMattersWithoutTrustByMatterCategoryChartOpen: true,
            isMattersWithoutTrustByMatterCategoryAndTypeChartOpen: true,
            isMattersWithoutTrustByPropertyChartOpen: true,
            isMattersWithoutTrustByPersonActingChartOpen: true,
            isMattersWithoutTrustByPersonResponsibleChartOpen: true,

            isFeesBilledInLast12MonthsOpen: true,
            isFeesBilledInLastFinancialYearOpen: true,
            isFeesBilledInLast14DaysMonthsOpen: true,
            isFeesBilledForMonthOpen: true,
            isFeesBilledMonthToDateByPersonActingOpen: true,
            isFeesBilledMonthToDateByPersonResponsibleOpen: true,
            isFeesBilledMonthToDateByMatterTypeOpen: true,
            isFeesBilledMonthToDateByMatterCategoryOpen: true,
            isFeesBilledMonthToDateByPropertyTypeOpen: true,
            isFeesBilledMonthToDateByReportingGroupOpen: true,
            isFeesBilledInLastYearByPersonActingOpen: true,
            isFeesBilledInLastYearByPersonResponsibleOpen: true,
            isFeesBilledInLastYearByMatterTypeOpen: true,
            isFeesBilledInLastYearByMatterCategoryOpen: true,
            isFeesBilledInLastYearByPropertyTypeOpen: true,
            isFeesBilledInLastYearByReportingGroupOpen: true,
            isInvoiceInDraftChartByPersonActingOpen: true,
            isInvoiceInDraftChartByPersonResponsibleOpen: true,
            isInvoiceInDraftChartByMatterTypeOpen: true,
            isInvoiceInDraftChartByMatterCategoryOpen: true,
            isInvoiceInDraftChartByPropertyTypeOpen: true,
            isInvoiceInDraftChartByReportingGroupOpen: true,

            IsAverageDaysLeadFollowUpByLawyerChartOpen: true,
            IsReferralsByLeadQualityChartOpen: true,
            IsLeadConversionInLast12MonthsByLawyerChartOpen: true,
            IsLeadsNotProceedingInLast12MonthsByReasonChartOpen: true,
            IsLeadConversionInLast30DaysByLawyerChartOpen: true,
            IsLeadsNotProceedingInLast30DaysByReasonChartOpen: true,
            IsLeadConversionInLast90DaysByLawyerChartOpen: true,
            IsLeadsNotProceedingInLast90DaysByReasonChartOpen: true,
            IsNewLeadsInLast12MonthsByAreaOfLawChartOpen: true,
            IsNewLeadsInLast12MonthsBySourceChartOpen: true,
            IsNewLeadsInLast30DaysByAreaOfLawChartOpen: true,
            IsNewLeadsInLast30DaysBySourceChartOpen: true,
            IsNewLeadsInLast30DaysByAssigneeChartOpen: true,
            IsNewLeadsInLast7DaysByAreaOfLawChartOpen: true,
            IsNewLeadsInLast7DaysBySourceChartOpen: true,
            IsNewLeadsInLast90DaysByAreaOfLawChartOpen: true,
            IsNewLeadsInLast90DaysBySourceChartOpen: true,
            IsNewLeadsInLast12MonthsTotalChartOpen: true,
            IsTopReferrersInLast30DaysChartOpen: true,
            IsTopReferrersInLast90DaysChartOpen: true,
            IsTopReferrersInLast12MonthsChartOpen: true,

            IsTimesheetTimeAndFeesInLastPeriodsChartOpen: true,
            IsTimesheetFeesInLastPeriodsChartOpen: true,
            IsTimesheetTimeInLastPeriodsChartOpen: true,
            IsTimesheetTimeInFinancialYearChartOpen: true,
            IsTimesheetFeesInFinancialYearChartOpen: true,
            IsTimesheetTimeInFinancialYearAggregateChartOpen: true,
            IsTimesheetFeesInFinancialYearAggregateChartOpen: true,

            isFeesBilledByPeriodPartChartOpen: true,
            isFeesBilledCumulativePartChartOpen: true,
            isFeesBilledCumulativeVsBudgetPartChartOpen: true,
            isFeesBilledPartChartOpen: true,
            isFeesBilledVsBudgetByPeriodPartChartOpen: true,
            isFeesBilledVsBudgetPartChartOpen: true,

            isFeesCollectedByPeriodPartChartOpen: true,
            isFeesCollectedCumulativePartChartOpen: true,
            isFeesCollectedCumulativeVsBudgetPartChartOpen: true,
            isFeesCollectedPartChartOpen: true,
            isFeesCollectedVsBudgetByPeriodPartChartOpen: true,
            isFeesCollectedVsBudgetPartChartOpen: true,

            isTimesheetFeesWithBudgetInLastPeriodsChartOpen: true,
            isTimesheetTimeWithBudgetInLastPeriodsChartOpen: true,
            isTimesheetTimeWithBudgetInFinancialYearChartOpen: true,
            isTimesheetFeesWithBudgetInFinancialYearChartOpen: true,
            isTimesheetTimeWithBudgetInFinancialYearAggregateChartOpen: true,
            isTimesheetFeesWithBudgetInFinancialYearAggregateChartOpen: true,
            isCumulativeBillableHoursVsBudgetChartOpen: true,

            isBillingRealisationChartOpen: true,

            isDebtorDaysByPersonActingChartOpen: true,
            isDebtorDaysByPersonResponsibleChartOpen: true,
            isDebtorDaysByMatterCategoryChartOpen: true,
            isDebtorDaysByMatterTypeChartOpen: true,
            isWIPLockUpDaysByPersonActingChartOpen: true,
            isWIPLockUpDaysByPersonResponsibleChartOpen: true,
            isWIPLockUpDaysByMatterCategoryChartOpen: true,
            isWIPLockUpDaysByMatterTypeChartOpen: true,

            isFutureSettlementsChartOpen: true,
            isFutureSettlementsByPriceChartOpen: true,

            isMatterDurationByCategoryOrTypeChartOpen: true,

            isSalesPipelineByAreaOfLawChartOpen: true,
            isSalesPipelineByAssigneeChartOpen: true,
            isSalesPipelineByLocationChartOpen: true,

            isEnquiriesByQualityChartOpen: true,
            isEnquiriesByLikelihoodToProceedChartOpen: true,

            isCollectionRateChartOpen: true,
            isClientBillingChartOpen: true,
            isDueDatesOverviewChartOpen: true,

            isHoursRecordedByStaffMembersChartOpen: true,
            isNonBillableTimesByActivityChartOpen: true,
            isNonBillableTimesByStaffChartOpen: true,
            isBillableTimesByStaffChartOpen: true,
            isTrustBalanceChartOpen: true,
            isDueDatesByPersonChartOpen: true,
            isMatterBillingChartOpen: true,
            isYearBudgetsChartOpen: true,
            isTaskQueueByAssigneeChartOpen: true,
            isTaskQueueByTaskTypeDescriptionChartOpen: true,
            isTaskQueueByCreationTimeChart: true,
            isFutureFeesChart: true,
            isClosedMattersByFeeEarnerChartOpen: true,
            isTrustFundsAvailableChartOpen: true,
            isFeesBilledVsBudgetByFeeEarnerChartOpen: true,
            isFeesRecordedVsBudgetByFeeEarnerChartOpen: true,
            isCombinedNewMattersChartByCategoryOpen: true,
            isNewMattersByPeriodsChartOpen: true,
            isMattersByCountryChartOpen: true,
            isCurrentMattersByAustralianStateChartOpen: true,

            isTrustBalancesByAgeChartOpen: true,
            isFeesBilledVsBudgetSpeedometerChartOpen: true,
            isTotalDebtOwingPieOpen: true,

            isFeesBilledVsBudgetByOfficeChartOpen: true,
            isFeesBilledVsBudgetByTeamChartOpen: true,
            isFeesBilledVsBudgetByDepartmentChartOpen: true,

            isBillableHoursRecordedVsBudgetOpen: true,

            isKpiSummaryOpen: true,

            isForecastFeesBilledChartOpen: true,
            isForecastFeesCollectedChartOpen: true,
            isForecastHoursChartOpen: true,

            isForecastFeesBilledByCategoryChartOpen: true,
            isForecastFeesCollectedByCategoryChartOpen: true,
            isForecastHoursByCategoryChartOpen: true,
            isFeesRecordedVsBudgetSpeedometerChartOpen: true,
            isFeesCollectedVsBudgetSpeedometerChartOpen: true,

            isBillableHoursRecordedVsBudgetSpeedometerOpen: true,

            isPhoneCallResponseTimeChartOpen: true,
            isTaskResponseTimeByAssigneeChartOpen: true,
            isTaskResponseTimeByTaskTypeChartOpen: true,
            isAverageElapsedTimeByTaskTypeChartOpen: true,
            isAverageElapsedTimeByAssigneeChartOpen: true,
            isFinancialYearBudgetForecastChart: true,
            isEnquiryHealthChartOpen: true,
            isContactActivitiesByStaffChartOpen: true,
            isContactActivitiesBySubjectChartOpen: true,

            isWriteOffOrOnAnalysisChartOpen: true,
            
            isNewMatterLeadsInLastTwelveMonthsByMatterTypeChartOpen: true,
            isNewMatterLeadsInLastTwelveMonthsByMatterCategoryChartOpen: true,
            isNewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChartOpen: true,
            isNewMatterLeadsInLastTwelveMonthsByPropertyChartOpen: true,
            isNewMatterLeadsInLastTwelveMonthsByActingChartOpen: true,
            isNewMatterLeadsInLastTwelveMonthsByResponsibleChartOpen: true,
            isNewMatterLeadsVsThreeYearAverageChartOpen: true,
            isCombinedNewMatterLeadsByCategoryChartOpen: true,
            isMatterLeadsOpenedLastTwelveMonthsOpen: true,
            isEnquiryActivityByPeriodChartOpen: true,
            isEnquiryActivityByUserChartOpen: true,
            isStaffUnbilledFeesChartOpen: true,
            isStaffUnbilledFeesByPeriodChartOpen: true,
        },
        featureLayoutList: [],
        selectedOption: undefined,
        additionalOption: undefined,
    });

    const featureLayoutQuery = useQuery<FeatureLayoutListData, FeatureLayoutParams>(FEATURE_LAYOUT_QUERY, {
        variables: {
            layoutId: props.layoutId,
            dashboardPanelId: props.chartFilter.dashboardPanel ? (props.chartFilter.dashboardPanel.value === 'all' ? null : props.chartFilter.dashboardPanel.value) : null,
            userGuid: props.layoutId === DashboardTypeEnum.ClientDashboard ? props.chartFilter.externalUser?.value : undefined,
            accessedFromDashboard: true
        },
    });

    // the dashboard's "Chart options" counts the charts of this panel from the layout, before any of them is mounted
    React.useEffect(() => {
        registerFeatureNames(state.featureLayoutList.map((layout: FeatureLayout) => layout.feature));
    }, [state.featureLayoutList, registerFeatureNames]);

    React.useMemo(() => {
        if (!featureLayoutQuery.loading && !featureLayoutQuery.error && featureLayoutQuery.data && featureLayoutQuery.data.featureLayoutList) {
            const { featureLayout } = featureLayoutQuery.data!.featureLayoutList;

            setFeatureLayoutList(featureLayout);

            rememberDashboardLayout(props.layoutId, props.chartFilter.dashboardPanel?.value, featureLayout.map((layout: FeatureLayout) => layout.feature));

            setState((prevState) => {
                return {
                    ...prevState,
                    featureLayoutList: featureLayout,
                };
            });

            setLoading(false);
        }
        // tslint:disable-next-line: align
    }, [featureLayoutQuery.data, featureLayoutQuery.error, featureLayoutQuery.loading]);

    React.useMemo(() => {
        if (props.isRefresh === true) {
            featureLayoutQuery.refetch({
                layoutId: props.layoutId,
                dashboardPanelId: props.chartFilter.dashboardPanel ? (props.chartFilter.dashboardPanel.value === 'all' ? null : props.chartFilter.dashboardPanel.value) : null,
                userGuid: props.layoutId === DashboardTypeEnum.ClientDashboard ? props.chartFilter.externalUser?.value : undefined,
                accessedFromDashboard: true
            });

            if (props.onRefresh) {
                props.onRefresh(false);
            }
        }
        // tslint:disable-next-line: align
    }, [props.isRefresh]);

    React.useMemo(() => {
        featureLayoutQuery.refetch({
            layoutId: props.layoutId,
            dashboardPanelId: props.chartFilter.dashboardPanel ? (props.chartFilter.dashboardPanel.value === 'all' ? null : props.chartFilter.dashboardPanel.value) : null,
            userGuid: props.layoutId === DashboardTypeEnum.ClientDashboard ? props.chartFilter.externalUser?.value : undefined,
            accessedFromDashboard: true
        });

        // tslint:disable-next-line: align
    }, [props.chartFilter, props.layoutId]);

    React.useMemo(() => {
        setLoading(true);

        if (props.search.length > 0) {
            // tslint:disable-next-line: no-shadowed-variable
            const featureLayoutList = state.featureLayoutList.filter((featureList: FeatureLayout, index: number) =>
                featureList.title.toLowerCase().includes(props.search.toLowerCase().trim()),
            );

            setFeatureLayoutList(featureLayoutList);
        } else {
            setFeatureLayoutList(state.featureLayoutList);
        }

        setTimeout(() => {
            setLoading(false);
        // tslint:disable-next-line: align
        }, 500);
        // tslint:disable-next-line: align
    }, [props.search]);

    // tslint:disable-next-line: no-any
    const onGetSelectedItem = (searchCriterias: any, isShowCompleted: boolean, title?: string, drillDownType?: DrillDownType, defaultView?: string, alternativeKey?: {
        // tslint:disable-next-line: align
        [key: string]: string; }, sortColumn?: string, sortDirection?: string, isIncludeNameFinancial?: boolean, isLead?: boolean) => {
        
            getSelectedItem(props.chartFilter, history, searchCriterias, isShowCompleted, title, drillDownType, defaultView, alternativeKey, sortColumn, sortDirection, isIncludeNameFinancial, isLead);
    };

    const onCloseChart = React.useCallback((category: string) => {
        setState((prevState) => {
            const { feature } = prevState;

            feature[category as keyof FeatureList] = false;

            return {
                ...prevState,
                feature: feature,
            };
        });
        // tslint:disable-next-line: align
    }, []);

    const onMaximize = React.useCallback((featureLayout: FeatureLayout | null) => (option?: number, additionalOption?: number) => {
        if (featureLayout)  {
            setState((prevState) => {
                return {
                    ...prevState,
                    isMaximizeOpen: true,
                    selectedFeatureName: featureLayout.feature,
                    description: featureLayout.description,
                    selectedOption: option,
                    additionalOption: additionalOption,
                    selectedFeatureLayout: featureLayout
                };
            });
        }  
        // tslint:disable-next-line: align
        }, [],
    );

    const onMaximizeSelected = React.useCallback((featureLayout: FeatureLayout | null) => (option?: {
        // tslint:disable-next-line: no-any
        [key: string]: any;
    }) => {
        
        if (featureLayout) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isMaximizeOpen: true,
                    selectedFeatureName: featureLayout.feature,
                    description: featureLayout.description,
                    maximizeSelected: option,
                    selectedFeatureLayout: featureLayout
                };
            });
        }

        // tslint:disable-next-line: align
    }, []);

    const onCloseMaximize = React.useCallback(() => {
        setState((prevState) => {
            return {
                ...prevState,
                isMaximizeOpen: false,
                selectedFeatureName: null,
                description: '',
            };
        });
        // tslint:disable-next-line: align
    }, []);

    // check if the dashboard is not in lead then set the entityType to 0 and entityGuid to undefined otherwise return the chartFilter
    const getChartEnquiryFilter = () => {
        if (props.layoutId !== DashboardTypeEnum.LEAD) {
            return {
                ...props.chartFilter,
                entityType: 0,
                entityGuid: undefined,
            };
        } else {
            return {
                ...props.chartFilter,
            };
        }
    };

    const isAIFeatureEnabled = (props.layoutId === DashboardTypeEnum.FIRM && UserFeature.HasAccess(UserFeatureEnum.hasFirmDashboardAICharts)) ||
                                (props.layoutId === DashboardTypeEnum.FEE_EARNER && UserFeature.HasAccess(UserFeatureEnum.hasFeeEarnerDashboardAICharts)) ||
                                (props.layoutId === DashboardTypeEnum.LEAD && UserFeature.HasAccess(UserFeatureEnum.hasEnquiriesDashboardChartsAI));

    const getFeatureComponents = (featureLayout: FeatureLayout, index: number) => {
        const featureName = featureLayout.feature;
        const description = featureLayout.description;

        if (featureName === 'MattersOpenedChart') {
            // 1
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersOpenedChart) &&
                state.feature.isMattersOpenedChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersOpenedChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersVsAverageChart') {
            // 2
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersVsAverageChart) &&
                state.feature.isMattersVsAverageChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersVsAverageChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByMatterTypeChart') {
            // 3
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByMatterTypeChart) &&
                state.feature.isByPeriodChartMatterType7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterType"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByMatterCategoryChart') {
            // 4
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByMatterCategoryChart) &&
                state.feature.isByPeriodChartMatterCategory7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategory"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByMatterCategoryAndTypeChart') {
            // 5
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByMatterCategoryAndTypeChart) &&
                state.feature.isByPeriodChartMatterCategoryAndType7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategoryAndType"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByPropertyChart') {
            // 6
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByPropertyChart) &&
                state.feature.isByPeriodChartProperty7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="Property"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByActingChart') {
            // 7
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByActingChart) &&
                state.feature.isByPeriodChartPersonActing7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonActing"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod7ByResponsibleChart') {
            // 8
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod7ByResponsibleChart) &&
                state.feature.isByPeriodChartPersonResponsible7Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonResponsible"
                                    periodInDays={7}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByMatterTypeChart') {
            // 9
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByMatterTypeChart) &&
                state.feature.isByPeriodChartMatterType30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterType"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByMatterCategoryChart') {
            // 10
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByMatterCategoryChart) &&
                state.feature.isByPeriodChartMatterCategory30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategory"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByMatterCategoryAndTypeChart') {
            // 11
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByMatterCategoryAndTypeChart) &&
                state.feature.isByPeriodChartMatterCategoryAndType30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategoryAndType"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByPropertyChart') {
            // 12
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByPropertyChart) &&
                state.feature.isByPeriodChartProperty30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="Property"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByActingChart') {
            // 13
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByActingChart) &&
                state.feature.isByPeriodChartPersonActing30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonActing"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriodByResponsibleChart') {
            // 14
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriodByResponsibleChart) &&
                state.feature.isByPeriodChartPersonResponsible30Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonResponsible"
                                    periodInDays={30}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByMatterTypeChart') {
            // 15
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByMatterTypeChart) &&
                state.feature.isByPeriodChartMatterType90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterType"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByMatterCategoryChart') {
            // 16
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByMatterCategoryChart) &&
                state.feature.isByPeriodChartMatterCategory90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategory"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByMatterCategoryAndTypeChart') {
            // 17
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByMatterCategoryAndTypeChart) &&
                state.feature.isByPeriodChartMatterCategoryAndType90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="MatterCategoryAndType"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByPropertyChart') {
            // 18
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByPropertyChart) &&
                state.feature.isByPeriodChartProperty90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="Property"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByActingChart') {
            // 19
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByActingChart) &&
                state.feature.isByPeriodChartPersonActing90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonActing"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByPeriod3ByResponsibleChart') {
            // 20
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByPeriod3ByResponsibleChart) &&
                state.feature.isByPeriodChartPersonResponsible90Open && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByPeriodChart
                                    groupBy="PersonResponsible"
                                    periodInDays={90}
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByMatterTypeChart') {
            // 21
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByMatterTypeChart) &&
                state.feature.isCurrentMatterChartMatterTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByMatterCategoryChart') {
            // 22
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByMatterCategoryChart) &&
                state.feature.isCurrentMatterChartMatterCategoryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByMatterCategoryAndTypeChart') {
            // 23
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByMatterCategoryAndTypeChart) &&
                state.feature.isCurrentMatterChartMatterCategoryAndTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByPropertyChart') {
            // 24
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByPropertyChart) &&
                state.feature.isCurrentMatterChartPropertyOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByActingChart') {
            // 25
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByActingChart) &&
                state.feature.isCurrentMatterChartPersonActingOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByResponsibleChart') {
            // 26
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByResponsibleChart) &&
                state.feature.isCurrentMatterChartPersonResponsibleOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterCountByReportingGroupChart') {
            // 26
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterCountByReportingGroupChart) &&
                state.feature.isCurrentMatterChartReportingGroupOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMatterChart
                                    groupBy="ReportingGroup"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByStatusChart') {
            // 27
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByStatusChart) &&
                state.feature.isMattersByStatusChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByStatusChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EstimatePerformanceChart') {
            // 28
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEstimatePerformanceChart) &&
                state.feature.isEstimatePerformanceChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <EstimatePerformanceChartV2
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterFeesVsEstimateChart') {
            // 29
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterFeesVsEstimateChart) &&
                state.feature.isMatterFeesVsEstimateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterFeesVsEstimate
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateTotalChart') {
            // 30
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateTotalChart) &&
                state.feature.isBilledVsEstimateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByMatterTypeChart') {
            // 31
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByMatterTypeChart) &&
                state.feature.isBilledFeesVsEstimateByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByMatterCategoryChart') {
            // 32
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByMatterCategoryChart) &&
                state.feature.isBilledFeesVsEstimateByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByMatterCategoryAndTypeChart') {
            // 33
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByMatterCategoryAndTypeChart) &&
                state.feature.isBilledFeesVsEstimateByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="MatterCategoryAndType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByPropertyChart') {
            // 34
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByPropertyChart) &&
                state.feature.isBilledFeesVsEstimateByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="Property"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByActingChart') {
            // 35
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByActingChart) &&
                state.feature.isBilledFeesVsEstimateByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BilledFeesVsEstimateByResponsibleChart') {
            // 36
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBilledFeesVsEstimateByResponsibleChart) &&
                state.feature.isBilledFeesVsEstimateByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BilledVsEstimateGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByMatterTypeChart') {
            // 37
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByMatterTypeChart) &&
                state.feature.isExpectedFutureFeesByMatterTypeChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={null}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByMatterCategoryChart') {
            // 38
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByMatterCategoryChart) &&
                state.feature.isExpectedFutureFeesByMatterCategoryChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={null}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByMatterCategoryAndTypeChart') {
            // 39
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByMatterCategoryAndTypeChart) &&
                state.feature.isExpectedFutureFeesByMatterCategoryAndTypeChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={null}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByPropertyChart') {
            // 40
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByPropertyChart) &&
                state.feature.isExpectedFutureFeesByPropertyChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={null}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByActingChart') {
            // 41
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByActingChart) &&
                state.feature.isExpectedFutureFeesByPersonActingChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ExpectedFutureFeesByResponsibleChart') {
            // 42
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasExpectedFutureFeesByResponsibleChart) &&
                state.feature.isExpectedFutureFeesByPersonResponsibleChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ExpectedFutureFeesChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={null}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByMatterTypeChart') {
            // 43
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByMatterTypeChart) &&
                state.feature.isUnbilledFeesByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByMatterCategoryChart') {
            // 44
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByMatterCategoryChart) &&
                state.feature.isUnbilledFeesByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByMatterCategoryAndTypeChart') {
            // 45
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByMatterCategoryAndTypeChart) &&
                state.feature.isUnbilledFeesByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByPropertyChart') {
            // 46
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByPropertyChart) &&
                state.feature.isUnbilledFeesByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByActingChart') {
            // 47
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByActingChart) &&
                state.feature.isUnbilledFeesByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledFeesByResponsibleChart') {
            // 48
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledFeesByResponsibleChart) &&
                state.feature.isUnbilledFeesByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledFeesChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByMatterTypeChart') {
            // 49
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByMatterTypeChart) &&
                state.feature.isUnbilledDisbursementsByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByMatterCategoryChart') {
            // 50
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByMatterCategoryChart) &&
                state.feature.isUnbilledDisbursementsByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByMatterCategoryAndTypeChart') {
            // 51
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByMatterCategoryAndTypeChart) &&
                state.feature.isUnbilledDisbursementsByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByPropertyChart') {
            // 52
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByPropertyChart) &&
                state.feature.isUnbilledDisbursementsByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByActingChart') {
            // 53
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByActingChart) &&
                state.feature.isUnbilledDisbursementsByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'UnbilledDisbursementsByResponsibleChart') {
            // 54
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasUnbilledDisbursementsByResponsibleChart) &&
                state.feature.isUnbilledDisbursementsByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <UnbilledDisbursementsChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TotalOwingChart') {
            // 55
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTotalOwingChart) &&
                state.feature.isTotalOwingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TotalOwingChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByMatterTypeChart') {
            // 56
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByMatterTypeChart) &&
                state.feature.isDebtOwingByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByMatterCategoryChart') {
            // 57
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByMatterCategoryChart) &&
                state.feature.isDebtOwingByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByMatterCategoryAndTypeChart') {
            // 58
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByMatterCategoryAndTypeChart) &&
                state.feature.isDebtOwingByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByPropertyChart') {
            // 59
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByPropertyChart) &&
                state.feature.isDebtOwingByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByActingChart') {
            // 60
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByActingChart) &&
                state.feature.isDebtOwingByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByResponsibleChart') {
            // 61
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByResponsibleChart) &&
                state.feature.isDebtOwingByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtOwingByClientChart') {
            // 256
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtOwingByClientChart) &&
                state.feature.isDebtOwingByClientChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtOwingChart
                                    groupBy="Client"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByMatterTypeChart') {
            // 62
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByMatterTypeChart) &&
                state.feature.isAverageFeeEstimatesCurrentByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByMatterCategoryChart') {
            // 63
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByMatterCategoryChart) &&
                state.feature.isAverageFeeEstimatesCurrentByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByMatterCategoryAndTypeChart') {
            // 64
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByMatterCategoryAndTypeChart) &&
                state.feature.isAverageFeeEstimatesCurrentByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByPropertyChart') {
            // 65
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByPropertyChart) &&
                state.feature.isAverageFeeEstimatesCurrentByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByActingChart') {
            // 66
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByActingChart) &&
                state.feature.isAverageFeeEstimatesCurrentByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageFeeEstimateCurrentByResponsibleChart') {
            // 67
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageFeeEstimateCurrentByResponsibleChart) &&
                state.feature.isAverageFeeEstimatesCurrentByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageFeeEstimatesCurrentChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByMatterTypeChart') {
            // 68
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByMatterTypeChart) &&
                state.feature.isAverageBilledFeesByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="MatterType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByMatterCategoryChart') {
            // 69
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByMatterCategoryChart) &&
                state.feature.isAverageBilledFeesByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="MatterCategory"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByMatterCategoryAndTypeChart') {
            // 70
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByMatterCategoryAndTypeChart) &&
                state.feature.isAverageBilledFeesByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="MatterCategoryAndType"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByPropertyChart') {
            // 71
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByPropertyChart) &&
                state.feature.isAverageBilledFeesByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="Property"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByActingChart') {
            // 72
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByActingChart) &&
                state.feature.isAverageBilledFeesByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="PersonActing"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageBilledFeesClosedByResponsibleChart') {
            // 73
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageBilledFeesClosedByResponsibleChart) &&
                state.feature.isAverageBilledFeesByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageBilledFeesChart
                                    groupBy="PersonResponsible"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ClosedMattersChart') {
            // 74
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasClosedMattersChart) &&
                state.feature.isClosedMattersChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ClosedMattersChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AgedUnbilledFeesChart') {
            // 77
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAgedUnbilledFeesChart) &&
                state.feature.isAgedUnbilledFeesChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AgedUnbilledFeesChart
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    getSelectedItem={onGetSelectedItem}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByMatterTypeChart') {
            // 80
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByMatterTypeChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByMatterCategoryChart') {
            // 81
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByMatterCategoryChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByMatterCategoryAndTypeChart') {
            // 82
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByMatterCategoryAndTypeChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="MatterCategoryAndType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByPropertyChart') {
            // 83
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByPropertyChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="Property"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByActingChart') {
            // 84
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByActingChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByResponsibleChart') {
            // 85
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByResponsibleChart) &&
                state.feature.isNewMattersInLastTwelveMonthsByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInPast14DaysChart') {
            // 86
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInPast14DaysChart) &&
                state.feature.isFeesBilledInLast14DaysMonthsOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLast14DaysChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLast12MonthsChart') {
            //     // 87
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLast12MonthsChart) &&
                state.feature.isFeesBilledInLast12MonthsOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLast12MonthsChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastFinancialYearChart') {
            // 88
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastFinancialYearChart) &&
                state.feature.isFeesBilledInLastFinancialYearOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastFinancialYearChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledForMonthChart') {
            // 89
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledForMonthChart) &&
                state.feature.isFeesBilledForMonthOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastMonthChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByActingChart') {
            // 90
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByActingChart) &&
                state.feature.isFeesBilledMonthToDateByPersonActingOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByResponsibleChart') {
            // 91
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByResponsibleChart) &&
                state.feature.isFeesBilledMonthToDateByPersonResponsibleOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByMatterTypeChart') {
            // 92
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByMatterTypeChart) &&
                state.feature.isFeesBilledMonthToDateByMatterTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByMatterCategoryChart') {
            // 93
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByMatterCategoryChart) &&
                state.feature.isFeesBilledMonthToDateByMatterCategoryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByPropertyTypeChart') {
            // 94
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByPropertyTypeChart) &&
                state.feature.isFeesBilledMonthToDateByPropertyTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="PropertyType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledMonthToDateByReportingGroupChart') {
            // 95
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledMonthToDateByReportingGroupChart) &&
                state.feature.isFeesBilledMonthToDateByReportingGroupOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledMonthToDateGroupedChart
                                    groupBy="ReportingGroup"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByActingChart') {
            // 96
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByActingChart) &&
                state.feature.isFeesBilledInLastYearByPersonActingOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByResponsibleChart') {
            // 97
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByResponsibleChart) &&
                state.feature.isFeesBilledInLastYearByPersonResponsibleOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByMatterTypeChart') {
            // 98
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByMatterTypeChart) &&
                state.feature.isFeesBilledInLastYearByMatterTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByMatterCategoryChart') {
            // 99
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByMatterCategoryChart) &&
                state.feature.isFeesBilledInLastYearByMatterCategoryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByPropertyTypeChart') {
            // 100
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByPropertyTypeChart) &&
                state.feature.isFeesBilledInLastYearByPropertyTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="PropertyType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledInLastYearByReportingGroupChart') {
            // 101
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledInLastYearByReportingGroupChart) &&
                state.feature.isFeesBilledInLastYearByReportingGroupOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceFeesBilledInLastYearGroupedChart
                                    groupBy="ReportingGroup"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByActingChart') {
            // 102
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByActingChart) &&
                state.feature.isInvoiceInDraftChartByPersonActingOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByResponsibleChart') {
            // 103
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByResponsibleChart) &&
                state.feature.isInvoiceInDraftChartByPersonResponsibleOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByMatterTypeChart') {
            // 104
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByMatterTypeChart) &&
                state.feature.isInvoiceInDraftChartByMatterTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByMatterCategoryChart') {
            // 105
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByMatterCategoryChart) &&
                state.feature.isInvoiceInDraftChartByMatterCategoryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByPropertyTypeChart') {
            // 106
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByPropertyTypeChart) &&
                state.feature.isInvoiceInDraftChartByPropertyTypeOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="PropertyType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'InvoicesInDraftByReportingGroupChart') {
            // 107
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasInvoicesInDraftByReportingGroupChart) &&
                state.feature.isInvoiceInDraftChartByReportingGroupOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <InvoiceInDraftGroupedChart
                                    groupBy="ReportingGroup"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByMatterTypeChart') {
            // 124
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByMatterTypeChart) &&
                state.feature.isMattersWithoutTrustByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByMatterCategoryChart') {
            // 125
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByMatterCategoryChart) &&
                state.feature.isMattersWithoutTrustByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByMatterCategoryAndTypeChart') {
            // 126
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByMatterCategoryAndTypeChart) &&
                state.feature.isMattersWithoutTrustByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="MatterCategoryAndType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByPropertyChart') {
            // 127
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByPropertyChart) &&
                state.feature.isMattersWithoutTrustByPropertyChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="Property"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByActingChart') {
            // 128
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByActingChart) &&
                state.feature.isMattersWithoutTrustByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersWithoutTrustByResponsibleChart') {
            // 129
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersWithoutTrustByResponsibleChart) &&
                state.feature.isMattersWithoutTrustByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersWithoutTrustGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterActivityChart') {
            // 130
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterActivityChart) &&
                state.feature.isMatterActivityChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterActivityChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'PipelineVsMatterActivityChart') {
            // 131
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasPipelineVsMatterActivityChart) &&
                state.feature.isPipelineVsMatterActivityChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <PipelineVsMatterActivityChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ClientExposureChart') {
            // 132
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasClientExposureChart) &&
                state.feature.isClientExposureChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ClientExposureChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={99}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TopReferrersInLastThirtyDaysChart') {
            // 133
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTopReferrersInLastThirtyDaysChart) &&
                state.feature.IsTopReferrersInLast30DaysChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TopReferrersByPeriodChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    period={'ThirtyDays'}
                                    index={99}
                                    chartFilter={props.chartFilter}
                                    description={description}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TopReferrersInLastNinetyDaysChart') {
            // 134
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTopReferrersInLastNinetyDaysChart) &&
                state.feature.IsTopReferrersInLast90DaysChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TopReferrersByPeriodChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    period={'NinetyDays'}
                                    index={99}
                                    chartFilter={props.chartFilter}
                                    description={description}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TopReferrersInLast12MonthsChart') {
            // 135
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTopReferrersInLast12MonthsChart) &&
                state.feature.IsTopReferrersInLast12MonthsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TopReferrersByPeriodChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    period={'TwelveMonths'}
                                    index={99}
                                    chartFilter={props.chartFilter}
                                    description={description}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeAndFeesInLastPeriodsChart') {
            // 136
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeAndFeesInLastPeriodsChart) &&
                state.feature.IsTimesheetTimeAndFeesInLastPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeAndFeesRecordedInPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetFeesInLastPeriodsChart') {
            // 137
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesInLastPeriodsChart) &&
                state.feature.IsTimesheetFeesInLastPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedInPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeInLastPeriodsChart') {
            // 137
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeInLastPeriodsChart) &&
                state.feature.IsTimesheetTimeInLastPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedInPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeInFinancialYearChart') {
            // 138
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeInFinancialYearChart) &&
                state.feature.IsTimesheetTimeInFinancialYearChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedInFinancialYearChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetFeesInFinancialYearChart') {
            // 139
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesInFinancialYearChart) &&
                state.feature.IsTimesheetFeesInFinancialYearChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedInFinancialYearChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeInFinancialYearAggregateChart') {
            // 140
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeInFinancialYearAggregateChart) &&
                state.feature.IsTimesheetTimeInFinancialYearAggregateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedInFinancialYearAggregateChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetFeesInFinancialYearAggregateChart') {
            // 141
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesInFinancialYearAggregateChart) &&
                state.feature.IsTimesheetFeesInFinancialYearAggregateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedInFinancialYearAggregateChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledChart') {
            // 142
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledChart) &&
                state.feature.isFeesBilledPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledVsBudgetChart') {
            // 143
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetChart) &&
                state.feature.isFeesBilledVsBudgetPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledCumulativeChart') {
            // 144
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledCumulativeChart) &&
                state.feature.isFeesBilledCumulativePartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledCumulativePartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledCumulativeVsBudgetChart') {
            // 145
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledCumulativeVsBudgetChart) &&
                state.feature.isFeesBilledCumulativeVsBudgetPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledCumulativeVsBudgetPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledByPeriodChart') {
            // 146
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledByPeriodChart) &&
                state.feature.isFeesBilledByPeriodPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledByPeriodPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledByPeriodVsBudgetChart') {
            // 147
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledByPeriodVsBudgetChart) &&
                state.feature.isFeesBilledVsBudgetByPeriodPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetByPeriodPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedChart') {
            // 148
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedChart) &&
                state.feature.isFeesCollectedPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedVsBudgetChart') {
            // 149
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedVsBudgetChart) &&
                state.feature.isFeesCollectedVsBudgetPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedVsBudgetPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedCumulativeChart') {
            // 150
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedCumulativeChart) &&
                state.feature.isFeesCollectedCumulativePartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedCumulativePartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
            // tslint:disable-next-line: max-line-length
        } else if (featureName === 'FeesCollectedCumulativeVsBudgetChart') {
            // 151
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedCumulativeVsBudgetChart) &&
                state.feature.isFeesCollectedCumulativeVsBudgetPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedCumulativeVsBudgetPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedByPeriodChart') {
            // 152
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedByPeriodChart) &&
                state.feature.isFeesCollectedByPeriodPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedByPeriodPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedByPeriodVsBudgetChart') {
            // 153
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedByPeriodVsBudgetChart) &&
                state.feature.isFeesCollectedVsBudgetByPeriodPartChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedVsBudgetByPeriodPartChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetFeesWithBudgetInLastPeriodsChart') {
            // 154
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesWithBudgetInLastPeriodsChart) &&
                state.feature.isTimesheetFeesWithBudgetInLastPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedWithBudgetInPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeWithBudgetInLastPeriodsChart') {
            // 155
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeWithBudgetInLastPeriodsChart) &&
                state.feature.isTimesheetTimeWithBudgetInLastPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedWithBudgetInPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeWithBudgetInFinancialYearChart') {
            // 156
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeWithBudgetInFinancialYearChart) &&
                state.feature.isTimesheetTimeWithBudgetInFinancialYearChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedWithBudgetInFinancialYearChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetFeesWithBudgetInFinancialYearChart') {
            // 157
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesWithBudgetInFinancialYearChart) &&
                state.feature.isTimesheetFeesWithBudgetInFinancialYearChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedWithBudgetInFinancialYearChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TimesheetTimeWithBudgetInFinancialYearAggregateChart') {
            // 158
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetTimeWithBudgetInFinancialYearAggregateChart) &&
                state.feature.isTimesheetTimeWithBudgetInFinancialYearAggregateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TimeRecordedWithBudgetInFinancialYearAggregateChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'TimesheetFeesWithBudgetInFinancialYearAggregateChart') {
            // 159
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTimesheetFeesWithBudgetInFinancialYearAggregateChart) &&
                state.feature.isTimesheetFeesWithBudgetInFinancialYearAggregateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedWithBudgetInFinancialYearAggregateChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BillingRealisationChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBillingRealisationChart) &&
                state.feature.isBillingRealisationChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BillingRealisationChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtorDaysByPersonActingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtorDaysByPersonActingChart) &&
                state.feature.isDebtorDaysByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtorDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="PersonActing"
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtorDaysByPersonResponsibleChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtorDaysByPersonResponsibleChart) &&
                state.feature.isDebtorDaysByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtorDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="PersonResponsible"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtorDaysByMatterCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtorDaysByMatterCategoryChart) &&
                state.feature.isDebtorDaysByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtorDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="MatterCategory"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DebtorDaysByMatterTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDebtorDaysByMatterTypeChart) &&
                state.feature.isDebtorDaysByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DebtorDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="MatterType"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'WIPLockUpDaysByPersonActingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasWIPLockUpDaysByPersonActingChart) &&
                state.feature.isWIPLockUpDaysByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <WipLockupDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="PersonActing"
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'WIPLockUpDaysByPersonResponsibleChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasWIPLockUpDaysByPersonResponsibleChart) &&
                state.feature.isWIPLockUpDaysByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <WipLockupDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="PersonResponsible"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'WIPLockUpDaysByMatterCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasWIPLockUpDaysByMatterCategoryChart) &&
                state.feature.isWIPLockUpDaysByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <WipLockupDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="MatterCategory"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'WIPLockUpDaysByMatterTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasWIPLockUpDaysByMatterTypeChart) &&
                state.feature.isWIPLockUpDaysByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <WipLockupDaysChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="MatterType"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FutureSettlementsChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFutureSettlementsChart) &&
                state.feature.isFutureSettlementsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FutureSettlementsCharts
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FutureSettlementsByPriceChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFutureSettlementsByPriceChart) &&
                state.feature.isFutureSettlementsByPriceChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FutureSettlementsByPriceChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterDurationByCategoryOrTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterDurationByCategoryOrTypeChart) &&
                state.feature.isMatterDurationByCategoryOrTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageMatterDurationChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CollectionRateChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCollectionRateChart) &&
                state.feature.isCollectionRateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CollectionRateChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ClientBillingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasClientBillingChart) &&
                state.feature.isClientBillingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ClientBillingChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'HoursRecordedByStaffMembersChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasHoursRecordedByStaffMembersChart) &&
                state.feature.isHoursRecordedByStaffMembersChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <HoursRecordedByStaffMemberChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NonBillableTimesByActivityChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNonBillableTimesByActivityChart) &&
                state.feature.isNonBillableTimesByActivityChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NonBillableTimesByActivityChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NonBillableTimesByStaffChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNonBillableTimesByStaffChart) &&
                state.feature.isNonBillableTimesByStaffChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NonBillableTimesByStaffChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DueDatesOverviewChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDueDatesOverviewChart) &&
                state.feature.isDueDatesOverviewChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DueDatesOverviewChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TrustBalanceChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTrustBalanceChart) &&
                state.feature.isTrustBalanceChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TrustBalanceChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    groupBy="Client"
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'DueDatesByPersonChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasDueDatesByPersonChart) &&
                state.feature.isDueDatesByPersonChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <DueDatesByPersonChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterBillingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterBillingChart) &&
                state.feature.isMatterBillingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CrmMatterBillingChart
                                    // getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    showScreenshot={true}
                                    onMaximize={onMaximize(featureLayout)}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'YearBudgetsChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasYearBudgetsChart) &&
                state.feature.isYearBudgetsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BudgetYearChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskQueueByAssigneeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskQueueByAssigneeChart) &&
                state.feature.isTaskQueueByAssigneeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskQueueByPeriodChart
                                    groupBy="AssignedToName"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskQueueByTaskTypeDescriptionChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskQueueByTaskTypeDescriptionChart) &&
                state.feature.isTaskQueueByTaskTypeDescriptionChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskQueueByPeriodChart
                                    groupBy="TaskTypeDescription"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskQueueByPriorityChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskQueueByPriorityChart) &&
                state.feature.isTaskQueueByAssigneeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskQueueByPeriodChart
                                    groupBy="Priority"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CostAgreementChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCostAgreementChart) &&
                state.feature.isCostAgreementsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CostAgreementsChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FutureFeesChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFutureFeesChart) &&
                state.feature.isFutureFeesChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FutureFeesChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskQueueByCreationTimeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskQueueByCreationTimeChart) &&
                state.feature.isTaskQueueByCreationTimeChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskByCreationTimesChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersInLastTwelveMonthsByReportingGroupChart') {
            // 85
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersInLastTwelveMonthsByReportingGroup) &&
                state.feature.isNewMattersInLastTwelveMonthsByReportingGroupChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersInLastTwelveMonthsGroupedChart
                                    groupBy="ReportingGroup"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ClosedMattersByFeeEarnerChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasClosedMattersByFeeEarnerChart) &&
                state.feature.isClosedMattersByFeeEarnerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ClosedMattersByFeeEarnerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TrustFundsAvailableChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTrustFundsAvailableChart) &&
                state.feature.isTrustFundsAvailableChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TrustFundsAvaialbleChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledVsBudgetByFeeEarnerChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetByFeeEarnerChart) &&
                state.feature.isFeesBilledVsBudgetByFeeEarnerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetByFeeEarnerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesRecordedVsBudgetByFeeEarnerChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesRecordedVsBudgetByFeeEarnerChart) &&
                state.feature.isFeesRecordedVsBudgetByFeeEarnerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedVsBudgetByFeeEarnerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CombinedNewMattersByCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCombinedNewMattersByCategoryChart) &&
                state.feature.isCombinedNewMattersChartByCategoryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CombinedNewMattersChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MattersByCountryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMattersByCountryChart) &&
                state.feature.isMattersByCountryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MattersByCountryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CurrentMattersByAustralianStateChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCurrentMattersByAustralianStateChart) &&
                state.feature.isCurrentMattersByAustralianStateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CurrentMattersByAustralianStatesChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'CurrentMattersByUSStateChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCurrentMattersByUSStateChart) &&
                state.feature.isCurrentMattersByAustralianStateChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <USMapChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'TrustBalancesByAgeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTrustBalancesByAgeChart) &&
                state.feature.isTrustBalancesByAgeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TrustBalanceByAgeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'FeesBilledVsBudgetSpeedometerChart') {
            // 145
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetSpeedometerChart) &&
                state.feature.isFeesBilledVsBudgetSpeedometerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetSpeedometerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TotalDebtOwingPieChart') {
            // 55
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTotalDebtOwingPieChart) &&
                state.feature.isTotalDebtOwingPieOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TotalDebtOwingPieChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'BillableTimesByStaffChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBillableTimesByStaffChart) &&
                state.feature.isBillableTimesByStaffChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BillableTimeByStaffChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledVsBudgetByOfficeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetByOfficeChart) &&
                state.feature.isFeesBilledVsBudgetByOfficeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetByGroupChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="Office"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledVsBudgetByTeamChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetByTeamChart) &&
                state.feature.isFeesBilledVsBudgetByTeamChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetByGroupChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="Team"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesBilledVsBudgetByDepartmentChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesBilledVsBudgetByDepartmentChart) &&
                state.feature.isFeesBilledVsBudgetByDepartmentChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesBilledVsBudgetByGroupChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="Department"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BillableHoursRecordedVsBudgetChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBillableHoursRecordedVsBudget) &&
                state.feature.isBillableHoursRecordedVsBudgetOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BillableHoursRecordedVsBudgetChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CumulativeBillableHoursVsBudgetChart') {
            // 467
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCumulativeBillableHoursVsBudgetChart ) &&
                state.feature.isCumulativeBillableHoursVsBudgetChartOpen  && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CumulativeBillableHoursVsBudgetChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'KpiSummaryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasKpiSummaryChart) &&
                state.feature.isKpiSummaryOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <KPISummaryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    showScreenshot={true}
                                    onMaximize={onMaximize(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        // enquiry charts
        } else if (featureName === 'NewLeadsInLast12MonthsTotal') {
            // 108
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast12MonthsTotal) &&
                state.feature.IsNewLeadsInLast12MonthsTotalChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast12MonthsTotal 
                            index={index} 
                            description={description} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadsNotProceedingInLast12MonthsByReason') {
            // 121
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadsNotProceedingInLast12MonthsByReason) &&
                state.feature.IsLeadsNotProceedingInLast12MonthsByReasonChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadsNotProceedingInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'TwelveMonths'}
                            groupBy={LeadsNotProceedingEnum.Reason}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadsNotProceedingInLast30DaysByReason') {
            // 122
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadsNotProceedingInLast30DaysByReason) &&
                state.feature.IsLeadsNotProceedingInLast12MonthsByReasonChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadsNotProceedingInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'ThirtyDays'}
                            groupBy={LeadsNotProceedingEnum.Reason}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadsNotProceedingInLast90DaysByReason') {
            // 123
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadsNotProceedingInLast90DaysByReason) &&
                state.feature.IsLeadsNotProceedingInLast90DaysByReasonChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadsNotProceedingInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'NinetyDays'}
                            groupBy={LeadsNotProceedingEnum.Reason}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'AverageDaysLeadFollowUpByLawyer') {
            // 117
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageDaysLeadFollowUpByLawyer) &&
                state.feature.IsAverageDaysLeadFollowUpByLawyerChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <AverageDaysLeadFollowUpByCategoryChart 
                            index={index} 
                            description={description} 
                            groupBy={AverageLeadsFollowUpByEnum.Lawyer} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast30DaysBySource') {
            // 111
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast30DaysBySource) &&
                state.feature.IsNewLeadsInLast30DaysBySourceChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast30DaysByGroupChart 
                            index={index} 
                            description={description} 
                            groupBy={NewLeadsEnum.Source} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast30DaysByAreaOfLaw') {
            // 112
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast30DaysByAreaOfLaw) &&
                state.feature.IsNewLeadsInLast30DaysByAreaOfLawChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast30DaysByGroupChart 
                            index={index} 
                            description={description} 
                            groupBy={NewLeadsEnum.AreaOfLaw} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast12MonthsBySource') {
            // 109
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast12MonthsBySource) &&
                state.feature.IsNewLeadsInLast12MonthsBySourceChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast12MonthsByGroupChart 
                            index={index} 
                            description={description} 
                            periodInMonths={12} 
                            groupBy={NewLeadsEnum.Source} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                            aiPrompt={featureLayout.aiPrompt ?? undefined}
                            layoutId={props.layoutId}
                            isAIFeatureEnabled={isAIFeatureEnabled}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast12MonthsByAreaOfLaw') {
            // 110
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast12MonthsByAreaOfLaw) &&
                state.feature.IsNewLeadsInLast12MonthsByAreaOfLawChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast12MonthsByGroupChart
                            index={index}
                            description={description}
                            periodInMonths={12}
                            groupBy={NewLeadsEnum.AreaOfLaw}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                            aiPrompt={featureLayout.aiPrompt ?? undefined}
                            layoutId={props.layoutId}
                            isAIFeatureEnabled={isAIFeatureEnabled}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast90DaysBySource') {
            // 115
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast90DaysBySource) &&
                state.feature.IsNewLeadsInLast90DaysBySourceChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast90DaysByGroupChart 
                            index={index} 
                            description={description} 
                            groupBy={NewLeadsEnum.Source} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast90DaysByAreaOfLaw') {
            // 116
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast90DaysByAreaOfLaw) &&
                state.feature.IsNewLeadsInLast90DaysByAreaOfLawChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast90DaysByGroupChart 
                            index={index} 
                            description={description} 
                            groupBy={NewLeadsEnum.AreaOfLaw} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadConversionInLast12MonthsByLawyer') {
            // 118
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadConversionInLast12MonthsByLawyer) &&
                state.feature.IsLeadConversionInLast12MonthsByLawyerChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadConversationInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'TwelveMonths'}
                            groupBy={LeadConversationEnum.Lawyer}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadConversionInLast90DaysByLawyer') {
            // 119
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadConversionInLast90DaysByLawyer) &&
                state.feature.IsLeadConversionInLast90DaysByLawyerChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadConversationInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'NinetyDays'}
                            groupBy={LeadConversationEnum.Lawyer}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'LeadConversionInLast30DaysByLawyer') {
            // 120
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasLeadConversionInLast30DaysByLawyer) &&
                state.feature.IsLeadConversionInLast30DaysByLawyerChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <LeadConversationInLastByPeriodChart
                            index={index}
                            description={description}
                            period={'ThirtyDays'}
                            groupBy={LeadConversationEnum.Lawyer}
                            onCloseChart={onCloseChart}
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'SalesPipelineByAreaOfLawChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasSalesPipelineByAreaOfLawChart) &&
                state.feature.isSalesPipelineByAreaOfLawChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <SalesPipelineChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                    groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'SalesPipelineByAssigneeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasSalesPipelineByAssigneeChart) &&
                state.feature.isSalesPipelineByAssigneeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <SalesPipelineChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                    groupBy="Assignee"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'SalesPipelineByLocationChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasSalesPipelineByLocationChart) &&
                state.feature.isSalesPipelineByLocationChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <SalesPipelineChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                    groupBy="Location"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EnquiriesByQualityChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEnquiriesByQualityChart) &&
                state.feature.isEnquiriesByQualityChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <EnquiriesByGroupChart
                                    // getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                    groupBy="Quality"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EnquiriesByLikelihoodToProceedChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEnquiriesByLikelihoodToProceedChart) &&
                state.feature.isEnquiriesByLikelihoodToProceedChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <EnquiriesByGroupChart
                                    // getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                    groupBy="LikelihoodToProceed"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'NewLeadsInLast7DaysBySource') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast7DaysBySource) &&
                state.feature.IsNewLeadsInLast7DaysBySourceChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInLast7DaysByGroupChart
                                    groupBy="Source"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    // chartFilter={props.chartFilter}
                                    chartFilter={getChartEnquiryFilter()}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast7DaysByAreaOfLaw') {
            // 112
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast7DaysByAreaOfLaw) &&
                state.feature.IsNewLeadsInLast7DaysByAreaOfLawChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInLast7DaysByGroupChart
                                    groupBy="AreaOfLaw"
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={getChartEnquiryFilter()}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ForecastFeesBilledChart') {
            // 112
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastFeesBilledChart) &&
                state.feature.isForecastFeesBilledChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastFeesBilledChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ForecastFeesCollectedChart') {
            // 112
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastFeesCollectedChart) &&
                state.feature.isForecastFeesCollectedChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastFeesCollectedChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ForecastHoursChart') {
            // 112
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastHoursChart) &&
                state.feature.isForecastHoursChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastHoursChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewLeadsInLast30DaysByAssignee') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewLeadsInLast30DaysByAssignee ) &&
                state.feature.IsNewLeadsInLast30DaysByAssigneeChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <NewLeadsInLast30DaysByGroupChart 
                            index={index} 
                            description={description} 
                            groupBy={NewLeadsEnum.Assignee} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        // end of enquiry chart
        } else if (featureName === 'ForecastFeesBilledByCategoryChart') {
            // 473
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastFeesBilledByCategoryChart) &&
                state.feature.isForecastFeesBilledByCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastFeesBilledByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ForecastFeesCollectedByCategoryChart') {
            // 474
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastFeesCollectedByCategoryChart) &&
                state.feature.isForecastFeesCollectedByCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastFeesCollectedByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ForecastHoursByCategoryChart') {
            // 475
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasForecastHoursByCategoryChart) &&
                state.feature.isForecastHoursByCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ForecastHoursByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesRecordedVsBudgetSpeedometerChart') {
            // 145
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesRecordedVsBudgetSpeedometerChart) &&
                state.feature.isFeesRecordedVsBudgetSpeedometerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesRecordedVsBudgetSpeedometerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'BillableHoursRecordedVsBudgetSpeedometerChart') {
            // 447
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasBillableHoursRecordedVsBudgetSpeedometerChart) &&
                state.feature.isBillableHoursRecordedVsBudgetSpeedometerOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BillableHoursRecordedVsBudgetSpeedometerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FeesCollectedVsBudgetSpeedometerChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFeesCollectedVsBudgetSpeedometerChart) &&
                state.feature.isFeesCollectedVsBudgetSpeedometerChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <FeesCollectedVsBudgetSpeedometerChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'PhoneCallResponseTimeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasPhoneCallResponseTimeChart) &&
                state.feature.isPhoneCallResponseTimeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <PhoneCallResponseTimeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageElapsedTimeByTaskTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageElapsedTimeByTaskType) &&
                state.feature.isAverageElapsedTimeByTaskTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageElapsedTimeByTaskTypeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'AverageElapsedTimeByAssigneeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasAverageElapsedTimeByAssignee) &&
                state.feature.isAverageElapsedTimeByAssigneeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <AverageElapsedTimeByAssigneeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskResponseTimeByAssignee') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskResponseTimeByAssignee  ) &&
                state.feature.isTaskResponseTimeByAssigneeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskResponseTimeByAssigneeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'TaskResponseTimeByTaskType') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasTaskResponseTimeByTaskType  ) &&
                state.feature.isTaskResponseTimeByTaskTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <TaskResponseTimeByTaskTypeChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    onMaximize={onMaximize(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'FinancialYearBudgetForecastChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasFinancialYearBudgetForecastChart) &&
                state.feature.isFinancialYearBudgetForecastChart && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <BudgetYearForecastChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EnquiryHealthChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEnquiryHealthChart) &&
                state.feature.isEnquiryHealthChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CrmEnquiresDataHealthChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                    // groupBy="AreaOfLaw"
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ContactActivitiesByStaff') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasContactActivitiesByStaff) &&
                state.feature.isContactActivitiesByStaffChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ContactActivitiesByStaffChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ContactActivitiesBySubject') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasContactActivitiesBySubject) &&
                state.feature.isContactActivitiesBySubjectChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <ContactActivityBySubjectChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'WriteOffOrOnAnalysisChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasWriteOffOrOnAnalysisChart) &&
                state.feature.isWriteOffOrOnAnalysisChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <WriteOffOnChart
                                getSelectedItem={onGetSelectedItem}
                                onCloseChart={onCloseChart}
                                description={description}
                                index={index}
                                chartFilter={props.chartFilter}
                                // onMaximize={onMaximize(featureLayout)}
                                onMaximizeSelected={onMaximizeSelected(featureLayout)}
                            />
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EventsAndCampaignSummaryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEventsAndCampaignSummaryChart) &&
                state.feature.isWriteOffOrOnAnalysisChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <EventsAndCampaignSummaryChart
                                getSelectedItem={onGetSelectedItem}
                                onCloseChart={onCloseChart}
                                description={description}
                                index={index}
                                chartFilter={props.chartFilter}
                                infoUrl={featureLayout.infoUrl}
                                // onMaximize={onMaximize(featureLayout)}
                                onMaximizeSelected={onMaximizeSelected(featureLayout)}
                            />
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsInLastTwelveMonthsByMatterTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsInLastTwelveMonthsByMatterTypeChart) &&
                state.feature.isNewMatterLeadsInLastTwelveMonthsByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInTheLastTwelveMonthsGroupedChart
                                    groupBy="MatterType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsInLastTwelveMonthsByMatterCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsInLastTwelveMonthsByMatterCategoryChart) &&
                state.feature.isNewMatterLeadsInLastTwelveMonthsByMatterCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInTheLastTwelveMonthsGroupedChart
                                    groupBy="MatterCategory"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChart) &&
                state.feature.isNewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInTheLastTwelveMonthsGroupedChart
                                    groupBy="MatterCategoryAndType"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsInLastTwelveMonthsByResponsibleChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsInLastTwelveMonthsByResponsibleChart) &&
                state.feature.isNewMatterLeadsInLastTwelveMonthsByResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInTheLastTwelveMonthsGroupedChart
                                    groupBy="PersonResponsible"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsInLastTwelveMonthsByActingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsInLastTwelveMonthsByActingChart) &&
                state.feature.isNewMatterLeadsInLastTwelveMonthsByActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsInTheLastTwelveMonthsGroupedChart
                                    groupBy="PersonActing"
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMatterLeadsVsThreeYearAverageChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMatterLeadsVsThreeYearAverageChart) &&
                state.feature.isNewMatterLeadsVsThreeYearAverageChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewLeadsVsThreeYearsAverageChart
                                    onCloseChart={onCloseChart}
                                    getSelectedItem={onGetSelectedItem}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'CombinedNewMatterLeadsByCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasCombinedNewMatterLeadsByCategoryChart) &&
                state.feature.isCombinedNewMatterLeadsByCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <CombinedNewLeadsByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    // onMaximize={onMaximize(featureLayout)}
                                    infoUrl={featureLayout.infoUrl}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        }  else if (featureName === 'MatterLeadsOpenedLastTwelveMonths') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterLeadsOpenedLastTwelveMonths) &&
                state.feature.isMatterLeadsOpenedLastTwelveMonthsOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <LeadsOpenedInTheLastTwelveMonthsChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'ReferralsByLeadQuality') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.HasReferralsByLeadQuality) &&
                state.feature.IsReferralsByLeadQualityChartOpen && (
                    <Grid className={`${classes.gridContainer} custom-GridContainer`} item={true} sm={6} xs={12} md={4} lg={3}>
                        <ReferralsByLeadQualityChart 
                            index={index} 
                            description={description} 
                            onCloseChart={onCloseChart} 
                            chartFilter={getChartEnquiryFilter()}
                        />
                    </Grid>
                )
            );
        } else if (featureName === 'MatterProfitabilityByCategoryChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterProfitabilityByCategoryChart) &&
                state.feature.isMatterProfitabilityByCategoryChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterProfitabilityByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="MatterCategory"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterProfitabilityByMatterTypeChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterProfitabilityByMatterTypeChart) &&
                state.feature.isMatterProfitabilityByMatterTypeChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterProfitabilityByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="MatterType"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterProfitabilityByPersonActingChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterProfitabilityByPersonActingChart) &&
                state.feature.isMatterProfitabilityByPersonActingChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterProfitabilityByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="PersonActing"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterProfitabilityByPersonResponsibleChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterProfitabilityByPersonResponsibleChart) &&
                state.feature.isMatterProfitabilityByPersonResponsibleChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterProfitabilityByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="PersonResponsible"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'MatterProfitabilityByClientChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasMatterProfitabilityByClientChart) &&
                state.feature.isMatterProfitabilityByClientChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <MatterProfitabilityByCategoryChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    groupBy="Client"
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'NewMattersByPeriodChart') {
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasNewMattersByPeriodsChart) &&
                state.feature.isNewMattersByPeriodsChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <NewMattersByPeriodsChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EnquiryActivityByPeriodChart') {
            // 600
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEnquiryActivityByPeriodChart) &&
                state.feature.isEnquiryActivityByPeriodChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <EnquiryActivityByPeriodChart
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'EnquiryActivityByUserChart') { 
            // 602
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasEnquiryActivityByUserChart) &&
                state.feature.isEnquiryActivityByUserChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <EnquiryActivityByUserChart
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    // onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                    // showAllRecords={false}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'StaffUnbilledFees') {
            // 608
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasStaffUnbilledFees) &&
                state.feature.isStaffUnbilledFeesChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <StaffUnbilledFeesChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                    onMaximizeSelected={onMaximizeSelected(featureLayout)}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else if (featureName === 'StaffUnbilledFeesByPeriod') {
            // 609
            return (
                UserFeature.HasAccess(UserFeatureEnum.hasStaffUnbilledFeesByPeriod) &&
                state.feature.isStaffUnbilledFeesByPeriodChartOpen && (
                    <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <LazyChartItem skeleton={getChartSkeleton(featureName)} featureName={featureName}>
                                <StaffUnbilledFeesByPeriodChart
                                    getSelectedItem={onGetSelectedItem}
                                    onCloseChart={onCloseChart}
                                    description={description}
                                    index={index}
                                    chartFilter={props.chartFilter}
                                    infoUrl={featureLayout.infoUrl}
                                    isAIFeatureEnabled={isAIFeatureEnabled}
                                    aiPrompt={featureLayout.aiPrompt ?? undefined}
                                    layoutId={props.layoutId}
                                />
                            </LazyChartItem>
                        </Grid>
                    </Grid>
                )
            );
        } else {
            return <div />;
        }
    };

    const onShowCharts = () => {

        let isShowCharts = true;

        if (
            // condition to show chart for not lead dashboard
            (props.layoutId !== DashboardTypeEnum.LEAD && props.chartFilter.entityType !== 0 && props.chartFilter.entityType !== 4) ||
            // condition to show chart for lead dashboard
            (props.layoutId === DashboardTypeEnum.LEAD && props.chartFilter.entityType !== 0)
        ) {
            if (props.chartFilter.entityGuid === undefined) {
                isShowCharts = false;
            } else if (!Guid.isGuid(props.chartFilter.entityGuid)) {
                isShowCharts = false;
            }
        }
        return isShowCharts;
    };

    if (featureLayoutQuery.loading || loading) {
        // Cards the size of real charts while the layout loads, so the page does not start tiny and then jump.
        return (
            <Grid className={classes.root} container={true} spacing={3}>
                {getInitialSkeletonVariants(props.layoutId, props.chartFilter.dashboardPanel?.value).map((variant, index) => (
                    <Grid key={index} className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                        <Grid className={`${classes.contentContainer} content-container`}>
                            <ChartSkeleton variant={variant} />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        );
    }
    return (
        <>
            {state.isMaximizeOpen && (
                <MaximizeChartDialog
                    open={state.isMaximizeOpen}
                    onClose={onCloseMaximize}
                    chartFilter={props.chartFilter}
                    selectedOption={state.selectedOption}
                    additionalOption={state.additionalOption}
                    selectedFeatureLayout={state.selectedFeatureLayout}
                    maximizeSelected={state.maximizeSelected}
                />
            )}
            <Grid className={classes.root} container={true} spacing={3} style={{ height: state.isMaximizeOpen ? '0' : ' auto' }}>
                {/* <Grid className={classes.gridContainer} item={true} sm={6} xs={12} md={4} lg={props.isFromSidebar ? 4 : 3}>
                    <Grid className={`${classes.contentContainer} content-container`}>
                        <div className="item">
                            <EventsAndCampaignSummaryChart
                                getSelectedItem={onGetSelectedItem}
                                onCloseChart={onCloseChart}
                                description={'description'}
                                index={123123123}
                                chartFilter={props.chartFilter}
                                infoUrl={''}
                            />
                        </div>
                    </Grid>
                </Grid> */}
                {featureLayoutList.map((featureLayout: FeatureLayout, index: number) => {
                    return <React.Fragment key={index}>{onShowCharts() === true ? getFeatureComponents(featureLayout, index) : null}</React.Fragment>;
                })}
            </Grid>
        </>
    );
};

// tslint:disable-next-line: no-any
export const getSelectedItem = (
    // tslint:disable-next-line: no-any
    chartFilter: ChartFilter,
    // tslint:disable-next-line: no-any
    history: any,
    // tslint:disable-next-line: no-any
    searchCriterias: any,
    isShowCompleted: boolean,
    title?: string,
    drillDownType?: DrillDownType,
    defaultView?: string,
    alternativeKey?: {
        // tslint:disable-next-line: no-any
        [key: string]: any;
    },
    sortColumn?: string,
    sortDirection?: string,
    isIncludeNameFinancial?: boolean,
    isLead?: boolean,
    // Optional, defaults to preserving the existing behaviour for every current caller -
    // opens the drilldown via history.push (same tab) instead of window.open (new tab) when
    // true. Explicit request: Quick View's own KPI widget drilldowns should stay in the same
    // tab when the panel is docked (the whole point of docking is to keep working in-page),
    // while every other chart's own drilldown - and Quick View's own undocked/overlay state -
    // keeps the existing new-tab behaviour untouched.
    openInSameTab?: boolean,
) => {
    // property: string, operator: string, comparison: any, isShowCompleted: boolean
    // For charts, this is a single item. But the property accepts multiple items. If required, change this implementation
    // property: string, operator: string, comparison: any, isShowCompleted: boolean
    // For charts, this is a single item. But the property accepts multiple items. If required, change this implementation

    let href = '';
    // Only populated for the matterSummaryDrillDown branch below - the one drilldown
    // destination openInSameTab is actually used for so far. Stays null for every other
    // branch, in which case openInSameTab silently has no effect and this falls back to the
    // existing window.open behaviour below.
    // tslint:disable-next-line: no-any
    let sameTabLocation: any = null;

    // TODO: Improve this
    if (drillDownType === DrillDownType.invoiceSummary) {
        href = history.createHref({
            pathname: '/invoiceSummary',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
                searchFilter: chartFilter.filter
            },
        });

        // // TODO: Review and remove these
        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');

        // tslint:disable-next-line: max-line-length
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
        sessionStorage.setItem('searchFilter', chartFilter.filter ? chartFilter.filter : '');

    } else if (drillDownType === DrillDownType.timesheetSummary) {
        href = history.createHref({
            pathname: '/timesheetDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
            },
        });

        // // TODO: Review and remove these
        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        // tslint:disable-next-line: max-line-length
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
    } else if (drillDownType === DrillDownType.staffBillingSummary) {
        href = history.createHref({
            pathname: '/staffBillingSummaryDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
            },
        });

        // // TODO: Review and remove these
        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        // tslint:disable-next-line: max-line-length
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
    } else if (drillDownType === DrillDownType.taskSummary) {
        href = history.createHref({
            pathname: '/tasksSummaryDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
                isShowCompleted: isShowCompleted
            },
        });

        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        // tslint:disable-next-line: max-line-length
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
        sessionStorage.setItem('isIncludeCompleted', isShowCompleted.toString());
    } else if (drillDownType === DrillDownType.notesSummary) {

        href = history.createHref({
            pathname: '/notesSummaryDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
                includeEventsAndCampaign: alternativeKey ? alternativeKey.includeEventsAndCampaign : null,
                isMyActivityOnly: alternativeKey ? alternativeKey.isMyActivityOnly : null,
            },
        });

        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
        sessionStorage.setItem('includeEventsAndCampaign', alternativeKey ? alternativeKey.includeEventsAndCampaign : '');
        sessionStorage.setItem('isMyActivityOnly', alternativeKey ? alternativeKey.isMyActivityOnly : ''); 

    } else if (drillDownType === DrillDownType.writeOnOffSummaryDrilldown) {

        href = history.createHref({
            pathname: '/writeOffOnSummaryDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
            },
        });

        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');

    } else if (drillDownType === DrillDownType.unbilledFeeEarnerDrilldown) {

        href = history.createHref({
            pathname: '/unbilledFeeEarnerDrilldown',
            state: {
                // Some extra state for this location that does not reside in the URL
                searchCriterias: JSON.stringify(searchCriterias),
                title: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
            },
        });

        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('title', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');

    } else {

        sameTabLocation = {
            pathname: '/matterSummaryDrillDown',
            state: {
                // Some extra state for this location that does not reside in the URL
                isShowCompleted: isShowCompleted,
                searchCriterias: JSON.stringify(searchCriterias),
                matterTitle: title ? title : '',
                chartFilter: chartFilter,
                entityType: chartFilter.entityType,
                entityGuid: chartFilter.entityGuid,
                responsibility: chartFilter.responsibility,
                defaultView: defaultView,
                searchFilter: chartFilter.filter,
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                isIncludeNameFinancial: isIncludeNameFinancial,
                isLead: isLead
            },
        };
        href = history.createHref(sameTabLocation);

        sessionStorage.setItem('isShowCurrent', true.toString());
        sessionStorage.setItem('isShowCompleted', isShowCompleted.toString());
        sessionStorage.setItem('searchCriterias', JSON.stringify(searchCriterias));
        sessionStorage.setItem('matterTitle', title ? title : '');
        sessionStorage.setItem('entityType', chartFilter.entityType ? chartFilter.entityType.toString() : '');
        sessionStorage.setItem('entityGuid', chartFilter.entityGuid ? chartFilter.entityGuid.toString() : '');
        sessionStorage.setItem('responsibility', chartFilter.responsibility ? chartFilter.responsibility.toString() : '');
        sessionStorage.setItem('defaultView', defaultView ? defaultView : '');
        sessionStorage.setItem('searchFilter', chartFilter.filter ? chartFilter.filter : '');
        sessionStorage.setItem('sortColumn', sortColumn ? sortColumn.toString() : '');
        sessionStorage.setItem('sortDirection', sortDirection ? sortDirection.toString() : '');
        sessionStorage.setItem('isIncludeNameFinancial', isIncludeNameFinancial ? isIncludeNameFinancial.toString() : '');
        sessionStorage.setItem('isLead', isLead ? isLead.toString() : '');
    }

    if (href && href.length > 0) {
        if (openInSameTab && sameTabLocation) {
            history.push(sameTabLocation);
        } else {
            window.open(href, '_blank');
        }
    }
};
